import "./illus1.css";

const Illus1 = ({ visible = false }) => {
  return (
    <svg
      className={visible ? "animated" : ""}
      id="freepik_stories-psychologist"
      version="1.1"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        className="animable"
        id="freepik--Floor--inject-16"
        style={{ transformOrigin: "250.13px 351.21px" }}
      >
        <ellipse
          className="animable"
          id="freepik--floor--inject-16"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "250.13px 351.21px",
          }}
          cx="250.13"
          cy="351.21"
          rx="243.34"
          ry="133.67"
        />
      </g>
      <g
        className="animable"
        id="freepik--Shadows--inject-16"
        style={{ transformOrigin: "254.055px 354.487px" }}
      >
        <path
          className="animable"
          id="freepik--Shadow--inject-16"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "349.511px 361.735px",
          }}
          d="M311.46,430.61l157.35-90.85c4.78-2.76,4.78-7.24,0-10l-63.93-36.9c-4.78-2.76-12.53-2.76-17.32,0L230.22,383.7c-4.79,2.76-4.79,7.24,0,10l63.92,36.91C298.92,433.37,306.68,433.37,311.46,430.61Z"
        />
        <path
          className="animable"
          id="freepik--shadow--inject-16"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "136.039px 369.861px",
          }}
          d="M229.59,407.66l-48.91-32.88,32.22-18.6c4.78-2.76,4.78-7.24,0-10L149,309.27c-4.79-2.76-12.54-2.76-17.32,0L39.3,362.6c-4.78,2.76-4.78,7.23,0,10l63.92,36.9c4.78,2.76,12.54,2.76,17.32,0l17.86-10.31,57.26,29.58c9.82,5.07,25.05,5,34-.2S238.61,414,229.59,407.66Z"
        />
        <path
          className="animable"
          id="freepik--shadow--inject-16"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "217.552px 312.067px",
          }}
          d="M277.56,312.44l-60.84-35.11a9.57,9.57,0,0,0-8.66,0L157.5,306.69c-2.38,1.38-2.38,3.62,0,5l60.84,35.11a9.54,9.54,0,0,0,8.66,0l50.55-29.34C280,316.07,280,313.82,277.56,312.44Z"
        />
      </g>
      <g
        className="animable"
        id="freepik--Diplomas--inject-16"
        style={{ transformOrigin: "106.77px 85.685px" }}
      >
        <g
          className="animable"
          id="freepik--Diploma--inject-16"
          style={{ transformOrigin: "72.965px 85.685px" }}
        >
          <g
            className="animable"
            id="freepik--Window--inject-16"
            style={{ transformOrigin: "72.965px 85.685px" }}
          >
            <polygon
              className="animable"
              id="el0edkmvjidy9"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "72.95px 104.525px",
              }}
              points="50.64 116.42 52.36 117.41 95.26 92.64 93.55 91.64 50.64 116.42"
            />
            <polygon
              className="animable"
              id="elljner3ftqwb"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "72.955px 85.68px",
              }}
              points="93.55 91.64 52.36 115.42 52.36 79.72 93.55 55.94 93.55 91.64"
            />
            <polygon
              className="animable"
              id="elrsdlg6ao1h"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "94.405px 73.795px",
              }}
              points="95.26 92.64 93.55 91.64 93.55 55.94 95.26 54.95 95.26 92.64"
            />
            <polygon
              className="animable"
              id="elj9xa32l215"
              style={{
                fill: "rgb(245, 245, 245)",
                transformOrigin: "72.955px 64.86px",
              }}
              points="96.98 51.98 95.26 50.99 48.93 77.74 50.64 78.73 96.98 51.98"
            />
            <polygon
              className="animable"
              id="el9r2wzqm3kw"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "49.785px 99.06px",
              }}
              points="48.93 77.74 50.64 78.73 50.64 120.38 48.93 119.39 48.93 77.74"
            />
            <path
              className="animable"
              id="elimzxn3k8l19"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "73.82px 86.19px",
              }}
              d="M97,52,50.64,78.73v41.65L97,93.63ZM95.26,92.63l-42.9,24.78V79.72L95.26,55Z"
            />
          </g>
          <path
            className="animable"
            id="eleaoc1rqzi65"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "85.47px 88.9781px",
            }}
            d="M85.47,85.64c1.6-.92,2.9-.17,2.9,1.67a6.4,6.4,0,0,1-2.9,5c-1.6.93-2.9.18-2.9-1.67A6.42,6.42,0,0,1,85.47,85.64Z"
          />
          <path
            className="animable"
            id="elo144vcljn5d"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "72.965px 73.105px",
            }}
            d="M62.06,78.1,83.87,65.5c.61-.35,1.1-.07,1.1.63v.06a2.45,2.45,0,0,1-1.1,1.91L62.06,80.71c-.61.35-1.1.07-1.1-.63V80A2.42,2.42,0,0,1,62.06,78.1Z"
          />
          <path
            className="animable"
            id="elszywln4ctt8"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "72.9549px 80.7148px",
            }}
            d="M58.61,88l28.7-16.57c.61-.35,1.1-.19,1.1.36a2.2,2.2,0,0,1-1.1,1.62L58.59,90c-.61.35-1.1.19-1.09-.37A2.21,2.21,0,0,1,58.61,88Z"
          />
          <path
            className="animable"
            id="elftzqsgnjzdb"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "72.9549px 84.7136px",
            }}
            d="M58.61,92l28.7-16.57c.61-.35,1.1-.19,1.1.36a2.2,2.2,0,0,1-1.1,1.62L58.59,94c-.61.35-1.1.18-1.09-.37A2.21,2.21,0,0,1,58.61,92Z"
          />
          <path
            className="animable"
            id="el39shpmiz08r"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "72.9549px 88.6533px",
            }}
            d="M58.61,95.94l28.7-16.57c.61-.35,1.1-.19,1.1.35a2.19,2.19,0,0,1-1.1,1.63L58.59,97.94c-.61.35-1.1.18-1.09-.37A2.21,2.21,0,0,1,58.61,95.94Z"
          />
          <path
            className="animable"
            id="el2l5eg9tdx81"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "70.2435px 98.7794px",
            }}
            d="M80.32,94.12a1.79,1.79,0,0,1-.72.19c-.62,0-.56-.63-.54-1.06,0-.19-.26-.49-.4-.24-.37.67-.85,1.3-1.25,1.95-.24.4-.71,1.3-1.3,1.17-.24,0-.32-.31-.33-.64a3.18,3.18,0,0,0,.39-1.79c0-.19-.34-.41-.44-.16a5.94,5.94,0,0,0-.37,1.65,10.4,10.4,0,0,1-.93,1.38c-.2.26-.37.56-.59.81,0,.05-.16.21-.24.22s-.18-.08-.21-.22a1.53,1.53,0,0,1,.1-.59h0s0,0,0-.05h0c0-.2-.25-.48-.35-.24a8.68,8.68,0,0,1-1.68,2.8l-.12.1c0-.12,0-.23,0-.35a3,3,0,0,0-.13-.78c0-.12-.27-.32-.39-.15a12.79,12.79,0,0,1-1.91,2.64,2.47,2.47,0,0,1-.4.28c-.13-.07.07-.77.1-.87.08-.32.18-.62.28-.93a2.79,2.79,0,0,0,.23-.76c0-.23-.37-.6-.44-.28,0,.13-.14.45-.26.83a20.6,20.6,0,0,1-1.61,2.73,6.3,6.3,0,0,1-2.25,2.16c-.25.14-.73.34-1,.14s-.25-.56-.26-.81a6.69,6.69,0,0,1,.27-2A12.38,12.38,0,0,0,66,99.5a8.47,8.47,0,0,0,1.88-2.08c.25-.46.41-1.22-.21-1.48-.43-.18-1,.12-1.34.32A5.91,5.91,0,0,0,65,97.32a7.8,7.8,0,0,0-1.71,3.13c-.06.18-.13.42-.2.69a5.32,5.32,0,0,1-3.16.52c-.06,0-.08.13,0,.14a5.27,5.27,0,0,0,3.09-.29c-.28,1.2-.43,2.78.69,3.09s2.46-1.09,3.06-1.89a12.81,12.81,0,0,0,1.2-1.94.76.76,0,0,1,.11-.14c0,.55.11,1,.65.87s1.06-.88,1.36-1.3.55-.82.82-1.24c0,.5.14,1.07.61,1s.88-.93,1.1-1.27a8.33,8.33,0,0,0,.55-.9.57.57,0,0,0,.11.16c.39.43.87,0,1.12-.36s.78-1,1.12-1.53a.94.94,0,0,0,.48.54c.61.28,1.19-.22,1.54-.67a13.16,13.16,0,0,0,1.16-1.86.86.86,0,0,0,.42.59,1.41,1.41,0,0,0,1.44-.1C80.7,94.43,80.52,94,80.32,94.12Zm-13.44,2.4c.29-.15.88-.39.91.09a1.63,1.63,0,0,1-.39.84,10.75,10.75,0,0,1-1.67,1.77,12.68,12.68,0,0,1-2.09,1.59A6.75,6.75,0,0,1,66.88,96.52Z"
          />
        </g>
        <g
          className="animable"
          id="freepik--diploma--inject-16"
          style={{ transformOrigin: "140.58px 85.685px" }}
        >
          <g
            className="animable"
            id="freepik--window--inject-16"
            style={{ transformOrigin: "140.58px 85.685px" }}
          >
            <polygon
              className="animable"
              id="elhyln91lcl0d"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "140.58px 104.525px",
              }}
              points="118.27 116.42 119.99 117.41 162.89 92.64 161.18 91.64 118.27 116.42"
            />
            <polygon
              className="animable"
              id="el9360v5gpazf"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "140.585px 85.68px",
              }}
              points="161.18 91.64 119.99 115.42 119.99 79.72 161.18 55.94 161.18 91.64"
            />
            <polygon
              className="animable"
              id="el1iy61b2dlyn"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "162.035px 73.795px",
              }}
              points="162.89 92.64 161.18 91.64 161.18 55.94 162.89 54.95 162.89 92.64"
            />
            <polygon
              className="animable"
              id="el1shfml07je9"
              style={{
                fill: "rgb(245, 245, 245)",
                transformOrigin: "140.58px 64.86px",
              }}
              points="164.61 51.98 162.89 50.99 116.55 77.74 118.27 78.73 164.61 51.98"
            />
            <polygon
              className="animable"
              id="elzl2dyttjadl"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "117.41px 99.06px",
              }}
              points="116.55 77.74 118.27 78.73 118.27 120.38 116.56 119.39 116.55 77.74"
            />
            <path
              className="animable"
              id="elva5rx05ie6h"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "141.44px 86.19px",
              }}
              d="M164.61,52,118.27,78.73v41.65l46.34-26.75Zm-1.72,40.65L120,117.41V79.72L162.89,55Z"
            />
          </g>
          <path
            className="animable"
            id="eleinn3lb9fil"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "153.095px 88.9781px",
            }}
            d="M153.1,85.64c1.6-.92,2.89-.17,2.89,1.67a6.39,6.39,0,0,1-2.89,5c-1.6.93-2.9.18-2.9-1.67A6.42,6.42,0,0,1,153.1,85.64Z"
          />
          <path
            className="animable"
            id="elqwjfrrx2zwj"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "140.595px 73.105px",
            }}
            d="M129.69,78.1,151.5,65.5c.61-.35,1.1-.07,1.1.63v.06a2.45,2.45,0,0,1-1.1,1.91L129.69,80.71c-.61.35-1.1.07-1.1-.63V80A2.42,2.42,0,0,1,129.69,78.1Z"
          />
          <path
            className="animable"
            id="el4jl0ibjubru"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "140.585px 80.7148px",
            }}
            d="M126.24,88l28.7-16.57c.61-.35,1.1-.19,1.1.36a2.2,2.2,0,0,1-1.1,1.62L126.21,90c-.6.35-1.09.19-1.08-.37A2.21,2.21,0,0,1,126.24,88Z"
          />
          <path
            className="animable"
            id="el3735j8lwdzg"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "140.585px 84.7136px",
            }}
            d="M126.24,92l28.7-16.57c.61-.35,1.1-.19,1.1.36a2.2,2.2,0,0,1-1.1,1.62L126.21,94c-.6.35-1.09.18-1.08-.37A2.21,2.21,0,0,1,126.24,92Z"
          />
          <path
            className="animable"
            id="ell70x27gefth"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "140.585px 88.6533px",
            }}
            d="M126.24,95.94l28.7-16.57c.61-.35,1.1-.19,1.1.35a2.19,2.19,0,0,1-1.1,1.63L126.21,97.94c-.6.35-1.09.18-1.08-.37A2.21,2.21,0,0,1,126.24,95.94Z"
          />
          <path
            className="animable"
            id="el6neka4mu2zu"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "137.888px 98.7744px",
            }}
            d="M147.94,94.12a1.75,1.75,0,0,1-.71.19c-.62,0-.56-.63-.54-1.06,0-.19-.26-.49-.41-.24-.37.67-.84,1.3-1.24,1.95-.24.4-.71,1.3-1.3,1.17-.24,0-.33-.31-.33-.64a3.27,3.27,0,0,0,.39-1.79c0-.19-.34-.41-.44-.16a5.6,5.6,0,0,0-.37,1.65,10.4,10.4,0,0,1-.93,1.38c-.2.26-.37.56-.59.81-.06.05-.16.21-.24.22s-.18-.08-.21-.22a1.36,1.36,0,0,1,.1-.59h0s0,0,0-.05h0c0-.2-.25-.48-.35-.24a8.68,8.68,0,0,1-1.68,2.8l-.12.1c0-.12,0-.23,0-.35a3,3,0,0,0-.13-.78c-.05-.12-.27-.32-.39-.15a12.79,12.79,0,0,1-1.91,2.64,3,3,0,0,1-.4.28c-.13-.07.07-.77.1-.87.08-.32.18-.62.28-.93a3.19,3.19,0,0,0,.23-.76c0-.23-.37-.6-.44-.28,0,.13-.14.45-.26.83a19.63,19.63,0,0,1-1.62,2.73,6.19,6.19,0,0,1-2.24,2.16c-.25.14-.73.34-1,.14s-.25-.56-.26-.81a6.69,6.69,0,0,1,.27-2,12.38,12.38,0,0,0,2.49-1.76,8.47,8.47,0,0,0,1.88-2.08c.25-.46.41-1.22-.21-1.48-.43-.18-1,.12-1.34.32a5.71,5.71,0,0,0-1.37,1.06,7.8,7.8,0,0,0-1.71,3.13c-.06.18-.13.42-.2.69a5.32,5.32,0,0,1-3.16.52c-.06,0-.08.13,0,.14a5.27,5.27,0,0,0,3.09-.29c-.28,1.2-.43,2.78.69,3.09s2.46-1.09,3.06-1.89a12.81,12.81,0,0,0,1.2-1.94.76.76,0,0,1,.11-.14c0,.55.1,1,.65.87s1.06-.88,1.36-1.3.55-.82.81-1.24c.05.5.15,1.07.62,1s.88-.93,1.1-1.27a8.33,8.33,0,0,0,.55-.9.54.54,0,0,0,.1.16c.4.43.87,0,1.13-.36s.78-1,1.12-1.53a.94.94,0,0,0,.48.54c.61.28,1.19-.22,1.54-.67a13.1,13.1,0,0,0,1.15-1.86.88.88,0,0,0,.43.59,1.41,1.41,0,0,0,1.44-.1C148.33,94.43,148.15,94,147.94,94.12Zm-13.43,2.4c.29-.15.88-.39.91.09a1.63,1.63,0,0,1-.39.84,10.75,10.75,0,0,1-1.67,1.77,13.11,13.11,0,0,1-2.09,1.59A6.75,6.75,0,0,1,134.51,96.52Z"
          />
        </g>
      </g>
      <g
        className="animable"
        id="freepik--Shelf--inject-16"
        style={{ transformOrigin: "412.905px 87.6926px" }}
      >
        <g
          className="animable"
          id="freepik--shelf--inject-16"
          style={{ transformOrigin: "412.905px 87.6926px" }}
        >
          <g
            className="animable"
            id="freepik--shelf--inject-16"
            style={{ transformOrigin: "412.905px 91.2336px" }}
          >
            <path
              className="animable"
              id="elc0n1sceq8wm"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "412.905px 91.2336px",
              }}
              d="M361,79.67v-4.2h0a1.44,1.44,0,0,1,.84-1.12l25.37-14.56a4.38,4.38,0,0,1,3.9,0L464,101.64a1.41,1.41,0,0,1,.84,1.12h0V107h0a1.43,1.43,0,0,1-.84,1.12l-25.36,14.55a4.32,4.32,0,0,1-3.9,0L361.81,80.79a1.45,1.45,0,0,1-.84-1.12Z"
            />
            <path
              className="animable"
              id="elau90olnf4z"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "412.905px 89.1136px",
              }}
              d="M464,103.88l-25.36,14.55a4.32,4.32,0,0,1-3.9,0L361.81,76.59a1.18,1.18,0,0,1,0-2.24l25.37-14.56a4.38,4.38,0,0,1,3.9,0L464,101.64A1.18,1.18,0,0,1,464,103.88Z"
            />
            <path
              className="animable"
              id="elecb3lmi00vh"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "450.76px 112.695px",
              }}
              d="M436.68,118.9v4.2a4,4,0,0,0,1.95-.47L464,108.08a1.43,1.43,0,0,0,.84-1.12h0v-4.2h0a1,1,0,0,0-.16-.47c.3.54.08,1.16-.68,1.59l-25.36,14.55A3.88,3.88,0,0,1,436.68,118.9Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--Book--inject-16"
            style={{ transformOrigin: "394.086px 75.9122px" }}
          >
            <polygon
              className="animable"
              id="el7mr68o6vg3a"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "394.56px 79.335px",
              }}
              points="423.06 83.4 401.57 95.65 366.06 75.28 387.55 63.02 423.06 83.4"
            />
            <path
              className="animable"
              id="elimjnivwpd2j"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "411.723px 86.08px",
              }}
              d="M401.32,94.72l20.73-11.9a8.64,8.64,0,0,1,.11-5.38L401.57,89.22S401.17,90.51,401.32,94.72Z"
            />
            <path
              className="animable"
              id="el4k4h7wn6iat"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "411.835px 86.0972px",
              }}
              d="M402.62,87.54a4.36,4.36,0,0,0-2,3.43v4c0,1.26.89,1.78,2,1.14l20.43-11.72v-1L402.9,94.89c-.66.38-1.2.07-1.2-.68l0-3.72a2.63,2.63,0,0,1,1.2-2l20.13-11.5V75.81Z"
            />
            <path
              className="animable"
              id="el8x1g70wap7q"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "394.081px 75.84px",
              }}
              d="M423.05,75.81l-35.5-20.37L367.12,67.16a4.37,4.37,0,0,0-2,3.43v4a1.39,1.39,0,0,0,.58,1.28l35.51,20.37a1.36,1.36,0,0,1-.59-1.28V91a4.39,4.39,0,0,1,2-3.43Z"
            />
            <path
              className="animable"
              id="el8f1dl6ly7bm"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "383.171px 82.415px",
              }}
              d="M401.21,89a4,4,0,0,0-.58,1.95v4a1.36,1.36,0,0,0,.59,1.28L365.71,75.88a1.39,1.39,0,0,1-.58-1.28v-4a4,4,0,0,1,.58-2Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--book--inject-16"
            style={{ transformOrigin: "429.413px 78.793px" }}
          >
            <polygon
              className="animable"
              id="eltrwu7nefgw8"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "432.84px 60.7px",
              }}
              points="444.9 52.91 445.11 55.62 421.11 68.49 420.57 66.91 444.9 52.91"
            />
            <polygon
              className="animable"
              id="el99m3dv2v6r"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "434.53px 62.22px",
              }}
              points="420.89 67.54 444.13 54.12 448.17 56.46 424.48 70.32 420.89 67.54"
            />
            <path
              className="animable"
              id="el72wlbsablpm"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "423.62px 87.095px",
              }}
              d="M428.84,68.88l2.3,26.94a1.92,1.92,0,0,1-.86,1.49l-13.48,7.8a1.78,1.78,0,0,1-.7.2l8.38-34.11a1.78,1.78,0,0,0,.7-.2l1-.56Z"
            />
            <path
              className="animable"
              id="elswg603bxamb"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "417.558px 86.013px",
              }}
              d="M423.45,71l-2.4-2.06-1.77-1.51c-.18-.29-.39-.5-.28-.74l-8.26,33.87v0c-.12.23-.15.77.17,1l4.17,3.57a1.86,1.86,0,0,0,1,.2l8.38-34.11A1.84,1.84,0,0,1,423.45,71Z"
            />
            <path
              className="animable"
              id="el7n8lvrdyu84"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "431.934px 61.7297px",
              }}
              d="M419.28,66.44c-.47.27-.36.58,0,1L423.45,71a1.87,1.87,0,0,0,1.72,0l3.67-2.12c.48-.27.56-.67.19-.88a1.7,1.7,0,0,0-1.54.11l-2.89,1.67a.64.64,0,0,1-.57,0l-3-2.65a.17.17,0,0,1,0-.33L444.9,52.91l-1.14-.66Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--book--inject-16"
            style={{ transformOrigin: "443.547px 84.2255px" }}
          >
            <polygon
              className="animable"
              id="els69qfesam0a"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "440.4px 82.56px",
              }}
              points="451.83 54.21 428.97 67.42 428.97 110.91 451.83 97.7 451.83 54.21"
            />
            <path
              className="animable"
              id="elt3t3ndsbibe"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "443.295px 63.145px",
              }}
              d="M429.7,68.14l22.13-12.7a9.3,9.3,0,0,0,5.06,2.77L435,70.85S433.53,70.52,429.7,68.14Z"
            />
            <path
              className="animable"
              id="elg6b49p09pjg"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "443.527px 62.4801px",
              }}
              d="M437.08,70.77a4.68,4.68,0,0,1-4.25,0l-3.73-2.13a1.29,1.29,0,0,1,0-2.45l21.81-12.51.92.53L430.38,66.59a.78.78,0,0,0,0,1.47l3.47,2a2.86,2.86,0,0,0,2.55,0l21.44-12.36,1,.6Z"
            />
            <path
              className="animable"
              id="el1t6uffjrdu7"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "443.55px 86.5151px",
              }}
              d="M458.88,58.26v43.49l-21.8,12.51a4.68,4.68,0,0,1-4.25,0l-3.73-2.13a1.48,1.48,0,0,1-.88-1.23V67.41a1.46,1.46,0,0,0,.88,1.22l3.73,2.15a4.74,4.74,0,0,0,4.25,0Z"
            />
            <path
              className="animable"
              id="elcamm8f87l6d"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "431.635px 91.0905px",
              }}
              d="M435,71.28a4.4,4.4,0,0,1-2.12-.5l-3.73-2.15a1.46,1.46,0,0,1-.88-1.22V110.9a1.48,1.48,0,0,0,.88,1.23l3.73,2.13a4.29,4.29,0,0,0,2.12.51Z"
            />
          </g>
        </g>
      </g>
      <g
        className="animable"
        id="freepik--side-table--inject-16"
        style={{ transformOrigin: "217.3px 273.51px" }}
      >
        <g
          className="animable"
          id="freepik--side-table--inject-16"
          style={{ transformOrigin: "217.3px 273.51px" }}
        >
          <g
            className="animable"
            id="freepik--side-table--inject-16"
            style={{ transformOrigin: "217.3px 276.945px" }}
          >
            <polygon
              className="animable"
              id="elviwxed62ewl"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "261.605px 315.34px",
              }}
              points="265.73 318.91 257.48 314.15 265.73 311.77 265.73 318.91"
            />
            <polygon
              className="animable"
              id="elu86yylwt2v"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "267.79px 314.15px",
              }}
              points="265.73 318.91 269.85 316.53 269.85 309.39 265.73 311.77 265.73 318.91"
            />
            <polygon
              className="animable"
              id="eldvhb6myjc5c"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "194.59px 322.2px",
              }}
              points="224.42 335.62 224.42 343.21 164.76 308.78 164.76 301.19 224.42 335.62"
            />
            <polygon
              className="animable"
              id="elhx30ynxy6vu"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "226.485px 338.225px",
              }}
              points="224.42 343.21 228.55 340.83 228.55 333.24 224.42 335.62 224.42 343.21"
            />
            <polygon
              className="animable"
              id="eleple44e4j6"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "190.465px 289.835px",
              }}
              points="160.63 241.67 220.3 276.1 220.3 338 160.63 303.57 160.63 241.67"
            />
            <polygon
              className="animable"
              id="el7vi918f21yc"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "247.135px 291.555px",
              }}
              points="220.3 276.1 273.97 245.11 273.97 307.01 220.3 338 220.3 276.1"
            />
            <polygon
              className="animable"
              id="eld8czwdr5e5"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "217.3px 243.39px",
              }}
              points="273.97 245.11 214.31 210.68 160.63 241.67 220.3 276.1 273.97 245.11"
            />
            <polygon
              className="animable"
              id="eldyzosn4iq2a"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "247.135px 301.08px",
              }}
              points="224.42 297.53 269.85 271.3 269.85 304.63 224.42 330.86 224.42 297.53"
            />
            <polygon
              className="animable"
              id="eli3qrddi9xu"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "247.135px 272.51px",
              }}
              points="224.42 278.48 269.85 252.25 269.85 266.54 224.42 292.77 224.42 278.48"
            />
            <g id="elkgg83ss5s3m">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.6",
                  transformOrigin: "261.605px 315.34px",
                }}
                points="265.73 318.91 257.48 314.15 265.73 311.77 265.73 318.91"
              />
            </g>
            <g id="eltfcqeukhuc">
              <polygon
                className="animable"
                style={{
                  opacity: "0.05",
                  transformOrigin: "261.605px 315.34px",
                }}
                points="265.73 318.91 257.48 314.15 265.73 311.77 265.73 318.91"
              />
            </g>
            <g id="eltgapmuqr5v">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.75",
                  transformOrigin: "267.79px 314.15px",
                }}
                points="265.73 318.91 269.85 316.53 269.85 309.39 265.73 311.77 265.73 318.91"
              />
            </g>
            <g id="elhtms1x2bw0p">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.6",
                  transformOrigin: "194.59px 322.2px",
                }}
                points="224.42 335.62 224.42 343.21 164.76 308.78 164.76 301.19 224.42 335.62"
              />
            </g>
            <g id="el4pxqg73b5zj">
              <polygon
                className="animable"
                style={{ opacity: "0.1", transformOrigin: "194.59px 322.2px" }}
                points="224.42 335.62 224.42 343.21 164.76 308.78 164.76 301.19 224.42 335.62"
              />
            </g>
            <g id="elvw4eznrsdd">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.75",
                  transformOrigin: "226.485px 338.225px",
                }}
                points="224.42 343.21 228.55 340.83 228.55 333.24 224.42 335.62 224.42 343.21"
              />
            </g>
            <g id="elb0gfnxt0lkm">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.6",
                  transformOrigin: "190.465px 289.835px",
                }}
                points="160.63 241.67 220.3 276.1 220.3 338 160.63 303.57 160.63 241.67"
              />
            </g>
            <g id="ellcybz75lqjr">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.75",
                  transformOrigin: "247.135px 291.555px",
                }}
                points="220.3 276.1 273.97 245.11 273.97 307.01 220.3 338 220.3 276.1"
              />
            </g>
            <g id="elylzyrfocn3r">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.85",
                  transformOrigin: "217.3px 243.39px",
                }}
                points="273.97 245.11 214.31 210.68 160.63 241.67 220.3 276.1 273.97 245.11"
              />
            </g>
            <g id="elhunus5ytxkp">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.7",
                  transformOrigin: "247.135px 301.08px",
                }}
                points="224.42 297.53 269.85 271.3 269.85 304.63 224.42 330.86 224.42 297.53"
              />
            </g>
            <g id="elrd0oek3fgai">
              <polygon
                className="animable"
                style={{
                  opacity: "0.1",
                  transformOrigin: "247.135px 309.355px",
                }}
                points="269.85 304.63 241.18 287.85 224.42 297.53 224.42 330.86 269.85 304.63"
              />
            </g>
            <g id="el8nsanbru93c">
              <polygon
                className="animable"
                style={{
                  opacity: "0.05",
                  transformOrigin: "255.515px 287.965px",
                }}
                points="269.85 304.63 241.18 287.85 269.85 271.3 269.85 304.63"
              />
            </g>
            <g id="elrufa62hzs7c">
              <polygon
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.85",
                  transformOrigin: "247.135px 272.51px",
                }}
                points="224.42 278.48 269.85 252.25 269.85 266.54 224.42 292.77 224.42 278.48"
              />
            </g>
            <path
              className="animable"
              id="el5q4c6ewf77n"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "246.745px 268.139px",
              }}
              d="M238.5,273.36c0,.66,2,.06,4.4-1.34l7.7-4.45c2.43-1.4,4.39-3.07,4.39-3.73v-1.19l-16.49,9.52Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--Plant--inject-16"
            style={{ transformOrigin: "215.523px 225.259px" }}
          >
            <g
              className="animable"
              id="freepik--shadow--inject-16"
              style={{ transformOrigin: "215.169px 239.263px" }}
            >
              <g id="elb8us43vohp6">
                <path
                  className="animable"
                  style={{
                    opacity: "0.1",
                    transformOrigin: "215.169px 239.263px",
                  }}
                  d="M224.29,234c5,2.91,5,7.62,0,10.53s-13.2,2.9-18.23,0-5-7.62,0-10.53S219.26,231.09,224.29,234Z"
                />
              </g>
            </g>
            <g
              className="animable"
              id="freepik--Pot--inject-16"
              style={{ transformOrigin: "215.523px 223.079px" }}
            >
              <path
                className="animable"
                id="elbiwyc3wyvjg"
                style={{
                  fill: "rgb(235, 235, 235)",
                  transformOrigin: "214.92px 232.114px",
                }}
                d="M222.53,239.68c4.06-4.15,6.45-14.51,2.49-17.8H204.84c-4,3.29-1.58,13.65,2.48,17.8a.57.57,0,0,0,.11.11l.14.14.37.33.1.07.3.24c.18.12.35.23.53.33a13.39,13.39,0,0,0,12.11,0h0a4.32,4.32,0,0,0,.53-.34l.29-.21.12-.1.35-.31.16-.16Z"
              />
              <path
                className="animable"
                id="elyuwtx8idmwr"
                style={{
                  fill: "rgb(250, 250, 250)",
                  transformOrigin: "214.923px 225.37px",
                }}
                d="M206.59,220.56c-4.61,2.66-4.61,7,0,9.62s12.07,2.66,16.67,0,4.61-7,0-9.62S211.19,217.9,206.59,220.56Z"
              />
              <path
                className="animable"
                id="el37e67n9gy8y"
                style={{
                  fill: "rgb(235, 235, 235)",
                  transformOrigin: "214.925px 225.37px",
                }}
                d="M209.85,222.44c-2.8,1.62-2.8,4.24,0,5.86a11.21,11.21,0,0,0,10.15,0c2.8-1.62,2.8-4.24,0-5.86A11.21,11.21,0,0,0,209.85,222.44Z"
              />
              <path
                className="animable"
                id="elxoppo4phdj"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "214.925px 226.76px",
                }}
                d="M220,225.22a11.21,11.21,0,0,0-10.15,0,4.7,4.7,0,0,0-1.68,1.54,4.7,4.7,0,0,0,1.68,1.54,11.21,11.21,0,0,0,10.15,0,4.7,4.7,0,0,0,1.68-1.54A4.7,4.7,0,0,0,220,225.22Z"
              />
              <path
                className="animable"
                id="eltfegsekj528"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "220.754px 215.66px",
                }}
                d="M215.24,227.51a13.36,13.36,0,0,0,11.81-7c4.31-7.85-.86-16.7-.86-16.7a13,13,0,0,1-5.28,3.56c-3.76,1.56-7.27,4.11-8,9.58A15.12,15.12,0,0,0,215.24,227.51Z"
              />
              <path
                className="animable"
                id="elbdufp50a94k"
                style={{
                  fill: "rgb(250, 250, 250)",
                  transformOrigin: "222.095px 216.205px",
                }}
                d="M226.6,206.5a14.86,14.86,0,0,1,0,5.64,20.26,20.26,0,0,1-1.78,5.4,22.19,22.19,0,0,1-3.19,4.71,23.15,23.15,0,0,1-4.31,3.66,37.7,37.7,0,0,0,3.87-4,27.81,27.81,0,0,0,3-4.67A24.42,24.42,0,0,0,226,212,19.64,19.64,0,0,0,226.6,206.5Z"
              />
              <path
                className="animable"
                id="elovhbvveay5s"
                style={{
                  fill: "rgb(250, 250, 250)",
                  transformOrigin: "223.194px 214.115px",
                }}
                d="M221.59,210.49a8.9,8.9,0,0,1,2.61,3.18,4.91,4.91,0,0,1,.66,2,3.3,3.3,0,0,1-.56,2.07l-.1,0c-.1-.71-.2-1.31-.34-1.92a18.61,18.61,0,0,0-.4-1.85,9.43,9.43,0,0,0-.8-1.78,8.61,8.61,0,0,0-1.14-1.62Z"
              />
              <path
                className="animable"
                id="elzfmyuw4b7x"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "210.736px 215.86px",
                }}
                d="M215.24,227.51s-8.25-.6-11.4-6.3c-3.31-6,.77-11.11-1.56-17,0,0,10.82,1.16,14.65,7.12C221.32,218.21,218.53,223.56,215.24,227.51Z"
              />
              <path
                className="animable"
                id="eltghdtocfzkl"
                style={{
                  fill: "rgb(250, 250, 250)",
                  transformOrigin: "209.494px 215.98px",
                }}
                d="M203.72,205.2a23.44,23.44,0,0,1,4.58,4.32,35.05,35.05,0,0,1,3.57,5.21,33.87,33.87,0,0,1,2.51,5.8,17.19,17.19,0,0,1,.87,6.23,22.25,22.25,0,0,0-1.42-6,37.86,37.86,0,0,0-2.62-5.63,42.9,42.9,0,0,0-3.36-5.22A35.76,35.76,0,0,0,203.72,205.2Z"
              />
              <path
                className="animable"
                id="el3lmhsb7e2yu"
                style={{
                  fill: "rgb(250, 250, 250)",
                  transformOrigin: "209.285px 216.156px",
                }}
                d="M205.85,215.44a12.89,12.89,0,0,1,3.62-.11,5.71,5.71,0,0,1,1.82.4,3.42,3.42,0,0,1,1.43,1.24l-.06.09c-.64-.11-1.17-.25-1.72-.39s-1.06-.4-1.62-.55a18,18,0,0,0-3.46-.58Z"
              />
              <g id="el264mfvxvze7">
                <path
                  className="animable"
                  style={{
                    opacity: "0.1",
                    transformOrigin: "220.754px 215.66px",
                  }}
                  d="M215.24,227.51a13.36,13.36,0,0,0,11.81-7c4.31-7.85-.86-16.7-.86-16.7a13,13,0,0,1-5.28,3.56c-3.76,1.56-7.27,4.11-8,9.58A15.12,15.12,0,0,0,215.24,227.51Z"
                />
              </g>
              <g id="elaquidou87i9">
                <path
                  className="animable"
                  style={{
                    opacity: "0.1",
                    transformOrigin: "219.715px 215.67px",
                  }}
                  d="M226.19,203.83a13,13,0,0,1-5.28,3.56c-3.76,1.56-7.27,4.11-8,9.58a15.12,15.12,0,0,0,2.29,10.54C228,218.26,227.18,208.46,226.19,203.83Z"
                />
              </g>
              <g id="el9knj79m6dn5">
                <path
                  className="animable"
                  style={{
                    opacity: "0.1",
                    transformOrigin: "210.737px 215.885px",
                  }}
                  d="M216.93,211.38c-3.83-6-14.65-7.12-14.65-7.12,2.7,1.08,13.31,12.34,13,23.25C218.53,223.56,221.32,218.21,216.93,211.38Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g
        className="animable"
        id="freepik--Divan--inject-16"
        style={{ transformOrigin: "356.75px 311.105px" }}
      >
        <g
          className="animable"
          id="freepik--divan--inject-16"
          style={{ transformOrigin: "356.75px 311.105px" }}
        >
          <path
            className="animable"
            id="elv2g834h9a8"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "302.8px 421.08px",
            }}
            d="M308.5,414.5H297.1l1.82,11.11h0A2,2,0,0,0,300,427a6.08,6.08,0,0,0,5.51,0,2,2,0,0,0,1.11-1.37h0Z"
          />
          <path
            className="animable"
            id="elkeqdn8pu4yb"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "243.5px 385.891px",
            }}
            d="M249.2,379.32H237.8l1.83,11.11h0a2.08,2.08,0,0,0,1.11,1.38,6.14,6.14,0,0,0,5.51,0,2.06,2.06,0,0,0,1.1-1.38h0Z"
          />
          <path
            className="animable"
            id="el81nuarg2esa"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "455.52px 332.88px",
            }}
            d="M461.22,326.31h-11.4l1.83,11.11h0a2,2,0,0,0,1.11,1.37,6.08,6.08,0,0,0,5.51,0,2,2,0,0,0,1.1-1.37h0Z"
          />
          <path
            className="animable"
            id="el3wzt1b2wka9"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "396.225px 297.701px",
            }}
            d="M401.92,291.13H390.53l1.82,11.11h0a2.11,2.11,0,0,0,1.11,1.38,6.14,6.14,0,0,0,5.51,0,2.06,2.06,0,0,0,1.1-1.38h0Z"
          />
          <path
            className="animable"
            id="elpzvdb62mak"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "350.53px 336.731px",
            }}
            d="M394.19,256.2l-2,1.17-17.81,30.31a22,22,0,0,1-6.83,6.83L238.07,369.25a3.06,3.06,0,0,0-1.79,2.45c0,.92,0,6.49,0,7.39a3,3,0,0,0,1.78,2.53l60.4,34.87a9.57,9.57,0,0,0,8.66,0l153.33-88.61a9.58,9.58,0,0,0,4.33-7.5V299.61a9.58,9.58,0,0,0-4.33-7.5l-59.91-34.58C398.16,256.14,395.31,255.55,394.19,256.2Z"
          />
          <path
            className="animable"
            id="el1m6q6nsmbhj"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "347.714px 334.664px",
            }}
            d="M458.48,301.43l-15.07,26.12a22,22,0,0,1-6.83,6.83L307.13,409.11a9.57,9.57,0,0,1-8.66,0l-60.4-34.86c-2.39-1.39-2.39-3.62,0-5l129.45-74.74a22,22,0,0,0,6.83-6.83l15.28-26a5,5,0,0,1,6.86-1.81l60.16,34.73A5,5,0,0,1,458.48,301.43Z"
          />
          <path
            className="animable"
            id="el336514azbcg"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "269.545px 394.662px",
            }}
            d="M302.8,410.16v7.37a8.83,8.83,0,0,1-4.33-1l-60.4-34.86a3,3,0,0,1-1.78-2.54c0-.87,0-6.28,0-7.34a3,3,0,0,0,1.79,2.5l60.4,34.87A8.86,8.86,0,0,0,302.8,410.16Z"
          />
          <path
            className="animable"
            id="ell7a4teh0kt"
            style={{
              fill: "rgb(11, 229, 179)",
              transformOrigin: "356.75px 300.297px",
            }}
            d="M233.74,349.14V362.6a9.58,9.58,0,0,0,4.33,7.5L298.47,405a9.51,9.51,0,0,0,8.66,0l125.65-72.54a22.57,22.57,0,0,0,6.89-6.8l37.53-62.94a21.3,21.3,0,0,0,2.56-9.29v-15.8a9.55,9.55,0,0,0-4.33-7.5L415,195.22a5,5,0,0,0-6.83,1.83l-15.95,32.23-21.7,33a31.34,31.34,0,0,1-4.55,5.51L240.35,340.33C235.68,343,233.74,346.38,233.74,349.14Z"
          />
          <path
            className="animable"
            id="elqlwmzmlz4z"
            style={{
              fill: "rgb(11, 229, 179)",
              transformOrigin: "357.084px 288.555px",
            }}
            d="M415,195.22l60.39,34.87a5,5,0,0,1,1.83,6.83l-37.65,65.22a22.15,22.15,0,0,1-6.83,6.83L307.13,381.51a9.57,9.57,0,0,1-8.66,0l-60.4-34.87c-2.39-1.38-2.39-3.62,0-5,8.45-9.12,20.34-16.53,32.23-18.6,9.85-10.74,19.57-15.86,32.5-18.76,8.65-11.34,19.67-17.67,32.49-18.77a50.18,50.18,0,0,1,28.44-16.41,22,22,0,0,0,6.83-6.83c4.13-13.57,9.42-23.66,21.7-33,2.53-11.94,6.88-24.16,15.95-32.23A5,5,0,0,1,415,195.22Z"
          />
          <path
            className="animable"
            id="eld25jenwpmnn"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "415.918px 221.429px",
            }}
            d="M418,223.05a2.66,2.66,0,1,0-3.41.65A2.46,2.46,0,0,0,418,223.05Z"
          />
          <path
            className="animable"
            id="elthzigpxp4w"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "351.57px 294.88px",
            }}
            d="M349.23,296.19a5.1,5.1,0,0,0,4.57,0c1.29-.72,1.34-1.89.11-2.62a5.1,5.1,0,0,0-4.57,0C348.05,294.3,348,295.47,349.23,296.19Z"
          />
          <path
            className="animable"
            id="eluuyfxe2exji"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "385.87px 314.695px",
            }}
            d="M383.53,316a5.1,5.1,0,0,0,4.57,0c1.29-.72,1.34-1.89.11-2.61a5.1,5.1,0,0,0-4.57,0C382.35,314.1,382.3,315.27,383.53,316Z"
          />
          <path
            className="animable"
            id="elg6c1f8i3mc"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "319.071px 313.695px",
            }}
            d="M316.73,315a5.07,5.07,0,0,0,4.57,0c1.29-.72,1.34-1.89.11-2.61a5.05,5.05,0,0,0-4.56,0C315.55,313.06,315.5,314.23,316.73,315Z"
          />
          <path
            className="animable"
            id="ely40a506wykt"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "353.354px 333.455px",
            }}
            d="M351,334.76a5.08,5.08,0,0,0,4.56,0c1.3-.72,1.35-1.89.11-2.61a5.08,5.08,0,0,0-4.56,0C349.86,332.87,349.81,334,351,334.76Z"
          />
          <path
            className="animable"
            id="eln9m8ey6c5c8"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "284.641px 331.295px",
            }}
            d="M282.31,332.6a5.08,5.08,0,0,0,4.56,0c1.29-.72,1.34-1.89.11-2.61a5.08,5.08,0,0,0-4.56,0C281.12,330.71,281.07,331.88,282.31,332.6Z"
          />
          <path
            className="animable"
            id="el65qcdfodsmk"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "318.949px 351.095px",
            }}
            d="M316.61,352.4a5.05,5.05,0,0,0,4.56,0c1.3-.72,1.35-1.89.12-2.61a5.07,5.07,0,0,0-4.57,0C315.43,350.51,315.38,351.68,316.61,352.4Z"
          />
          <path
            className="animable"
            id="elfj9z1v9are8"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "452.915px 242.445px",
            }}
            d="M455,244.05a2.65,2.65,0,1,0-3.41.66A2.47,2.47,0,0,0,455,244.05Z"
          />
          <path
            className="animable"
            id="elkd18gp460qd"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "397.19px 252.54px",
            }}
            d="M399.27,254.15a2.65,2.65,0,1,0-3.41.65A2.46,2.46,0,0,0,399.27,254.15Z"
          />
          <path
            className="animable"
            id="el6pgia6rjy95"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "433.71px 273.97px",
            }}
            d="M435.79,275.58a2.65,2.65,0,1,0-3.41.65A2.46,2.46,0,0,0,435.79,275.58Z"
          />
          <g id="elono7dc9n4w9">
            <path
              className="animable"
              style={{ opacity: "0.5", transformOrigin: "356.75px 300.297px" }}
              d="M233.74,349.14V362.6a9.58,9.58,0,0,0,4.33,7.5L298.47,405a9.51,9.51,0,0,0,8.66,0l125.65-72.54a22.57,22.57,0,0,0,6.89-6.8l37.53-62.94a21.3,21.3,0,0,0,2.56-9.29v-15.8a9.55,9.55,0,0,0-4.33-7.5L415,195.22a5,5,0,0,0-6.83,1.83l-15.95,32.23-21.7,33a31.34,31.34,0,0,1-4.55,5.51L240.35,340.33C235.68,343,233.74,346.38,233.74,349.14Z"
            />
          </g>
          <g id="elvqzupvbcqq">
            <path
              className="animable"
              style={{ opacity: "0.1", transformOrigin: "268.27px 373.967px" }}
              d="M302.8,382.56V406a8.83,8.83,0,0,1-4.33-1l-60.4-34.87a9.58,9.58,0,0,1-4.33-7.5V349.15a9.69,9.69,0,0,1,3.89-7.22c-1.94,1.39-1.79,3.43.44,4.72l60.4,34.87A8.86,8.86,0,0,0,302.8,382.56Z"
            />
          </g>
          <g id="elv2p14mun0n">
            <path
              className="animable"
              style={{ opacity: "0.3", transformOrigin: "357.084px 288.555px" }}
              d="M415,195.22l60.39,34.87a5,5,0,0,1,1.83,6.83l-37.65,65.22a22.15,22.15,0,0,1-6.83,6.83L307.13,381.51a9.57,9.57,0,0,1-8.66,0l-60.4-34.87c-2.39-1.38-2.39-3.62,0-5,8.45-9.12,20.34-16.53,32.23-18.6,9.85-10.74,19.57-15.86,32.5-18.76,8.65-11.34,19.67-17.67,32.49-18.77a50.18,50.18,0,0,1,28.44-16.41,22,22,0,0,0,6.83-6.83c4.13-13.57,9.42-23.66,21.7-33,2.53-11.94,6.88-24.16,15.95-32.23A5,5,0,0,1,415,195.22Z"
            />
          </g>
          <g id="elol1z9sabvii">
            <path
              className="animable"
              style={{ opacity: "0.1", transformOrigin: "422.506px 250.4px" }}
              d="M475.43,230.09,415,195.22a5,5,0,0,0-6.83,1.83c-9.07,8.07-13.42,20.29-15.95,32.23-12.28,9.33-17.57,19.42-21.7,33a20.2,20.2,0,0,1-3.37,4.11h0l69,39.86a20.2,20.2,0,0,0,3.37-4.11l37.65-65.22A5,5,0,0,0,475.43,230.09Z"
            />
          </g>
          <g id="el65c57driweu">
            <path
              className="animable"
              style={{ opacity: "0.15", transformOrigin: "416.653px 221.99px" }}
              d="M425.33,226.81c-2-.55-4.08-1-5.67-2.47a7.09,7.09,0,0,1-1.17-1.44,5.09,5.09,0,0,0-.86-1.35.69.69,0,0,0-.41-.13,7.78,7.78,0,0,1,1.5-3.91,13.56,13.56,0,0,1,1.36-1.83c.45-.47,1-.89,1.4-1.4.08-.1,0-.35-.12-.34a3.65,3.65,0,0,0-2.06,1.19,10.81,10.81,0,0,0-1.95,2.37,9.52,9.52,0,0,0-1,2.21,5.78,5.78,0,0,0-.22,1,3.25,3.25,0,0,0,0,.53,1.72,1.72,0,0,0-.66-.26,12.42,12.42,0,0,1-3.49-1.6,8.64,8.64,0,0,1-3.93-4.54c0-.08-.11,0-.1.09a8.2,8.2,0,0,0,.83,2.12,8.36,8.36,0,0,0,1.39,1.9,12.32,12.32,0,0,0,3.81,2.41,9.58,9.58,0,0,0,1.34.45,6.57,6.57,0,0,0-2.52,2.92A8.54,8.54,0,0,0,412,230c0,.09.1,0,.11,0a20.56,20.56,0,0,1,.43-2.32,12.15,12.15,0,0,1,.94-2.38,6.24,6.24,0,0,1,2.93-3,.36.36,0,0,0,.25-.43h0a.45.45,0,0,0,.23,0,3.83,3.83,0,0,0,.74,1.43,8.53,8.53,0,0,0,1.54,1.69,8.65,8.65,0,0,0,2.48,1.47,10.22,10.22,0,0,0,1.81.46,6.46,6.46,0,0,0,1.81,0C425.36,227,425.38,226.83,425.33,226.81Z"
            />
          </g>
          <g id="el5uzraeg2be5">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "352.238px 295.576px",
              }}
              d="M342.29,300.54a10.85,10.85,0,0,1,4.79-3.45,13.24,13.24,0,0,1,2.19-.49,9.38,9.38,0,0,0,2-.27.57.57,0,0,0,.29-.26,13.19,13.19,0,0,1,4.63,2.05,16.38,16.38,0,0,1,2,1.43c.49.44.87.94,1.42,1.36.11.08.45.11.47,0,.15-.59-.43-1.25-.95-1.78a12.58,12.58,0,0,0-2.52-2,15.88,15.88,0,0,0-2.58-1.27,10.31,10.31,0,0,0-1.26-.41c-.25-.06-.47-.12-.69-.15a1.51,1.51,0,0,0,.53-.4,11.19,11.19,0,0,1,3.05-2.11,14.49,14.49,0,0,1,7-1.69c.12,0,0-.09-.08-.09a17.36,17.36,0,0,0-3,.07,14,14,0,0,0-2.85.52,13.62,13.62,0,0,0-4.19,2.13,6.07,6.07,0,0,0-1,.85,7.23,7.23,0,0,0-3.08-2.54,17.89,17.89,0,0,0-6.62-1.87c-.12,0-.08.06,0,.08,1,.28,1.95.54,2.88.89a20.1,20.1,0,0,1,2.81,1.27c1.4.78,2.7,1.76,3,2.84a.49.49,0,0,0,.48.29h0a.28.28,0,0,0,0,.18,8.12,8.12,0,0,0-2.06.17,14.55,14.55,0,0,0-2.62.68,9,9,0,0,0-2.59,1.42,6.16,6.16,0,0,0-1.11,1.19,2.88,2.88,0,0,0-.55,1.29S342.25,300.57,342.29,300.54Z"
            />
          </g>
          <g id="el13ahmsgdqr9k">
            <path
              className="animable"
              style={{ opacity: "0.15", transformOrigin: "386.478px 315.38px" }}
              d="M376.59,320.34a10.93,10.93,0,0,1,4.79-3.45,12.3,12.3,0,0,1,2.19-.48,10.26,10.26,0,0,0,2-.28.55.55,0,0,0,.28-.26,13.38,13.38,0,0,1,4.63,2.05,16.26,16.26,0,0,1,2,1.44,18.14,18.14,0,0,0,1.41,1.35c.11.09.45.12.48,0,.14-.59-.44-1.25-1-1.78a12.66,12.66,0,0,0-2.52-2,17.69,17.69,0,0,0-2.58-1.27,11.6,11.6,0,0,0-1.26-.4,5.08,5.08,0,0,0-.69-.15,1.44,1.44,0,0,0,.53-.41,11.19,11.19,0,0,1,3.05-2.11,14.63,14.63,0,0,1,7-1.69c.12,0,0-.08-.08-.09a18.44,18.44,0,0,0-3,.07,15.66,15.66,0,0,0-2.85.52,14,14,0,0,0-4.19,2.13,7.19,7.19,0,0,0-1,.85,7.21,7.21,0,0,0-3.08-2.53,17.9,17.9,0,0,0-6.62-1.88c-.12,0-.08.06,0,.08,1,.28,1.95.55,2.88.89a22.08,22.08,0,0,1,2.82,1.27c1.39.78,2.69,1.76,3,2.85a.48.48,0,0,0,.48.28v0a.33.33,0,0,0,0,.17,8,8,0,0,0-2.05.18,14.66,14.66,0,0,0-2.63.68,9.11,9.11,0,0,0-2.59,1.42A6.12,6.12,0,0,0,377,319a3,3,0,0,0-.55,1.29S376.55,320.38,376.59,320.34Z"
            />
          </g>
          <g id="elmvftxz678d">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "319.693px 314.343px",
              }}
              d="M309.79,319.3a10.85,10.85,0,0,1,4.79-3.45,12.3,12.3,0,0,1,2.19-.48,10.15,10.15,0,0,0,2-.28.59.59,0,0,0,.28-.26,13.52,13.52,0,0,1,4.64,2.05,16.13,16.13,0,0,1,2,1.44,18.14,18.14,0,0,0,1.41,1.35c.11.08.45.12.48,0,.14-.59-.44-1.25-1-1.78a12.31,12.31,0,0,0-2.52-2,16.3,16.3,0,0,0-2.58-1.27c-.4-.15-.82-.29-1.26-.41l-.69-.15a1.32,1.32,0,0,0,.53-.4,11.19,11.19,0,0,1,3.05-2.11,14.55,14.55,0,0,1,7-1.69c.12,0,0-.09-.08-.09a17.36,17.36,0,0,0-3,.07,14.85,14.85,0,0,0-2.85.52A13.74,13.74,0,0,0,320,312.5a7.19,7.19,0,0,0-1,.85,7.23,7.23,0,0,0-3.08-2.54,18,18,0,0,0-6.62-1.87c-.12,0-.08.06,0,.08,1,.28,1.95.55,2.88.89a20.77,20.77,0,0,1,2.82,1.27c1.4.78,2.69,1.76,3,2.84a.49.49,0,0,0,.48.29v0a.25.25,0,0,0,0,.17,8,8,0,0,0-2.06.17,15.55,15.55,0,0,0-2.63.68,9.37,9.37,0,0,0-2.59,1.42,6.49,6.49,0,0,0-1.11,1.19,2.86,2.86,0,0,0-.54,1.29S309.75,319.33,309.79,319.3Z"
            />
          </g>
          <g id="el4qtfh5dsqcs">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "354.051px 334.146px",
              }}
              d="M344.09,339.1a11,11,0,0,1,4.8-3.45,13,13,0,0,1,2.19-.48,9.45,9.45,0,0,0,2-.28.55.55,0,0,0,.28-.26,13.71,13.71,0,0,1,4.64,2.05,17.24,17.24,0,0,1,2,1.44,18.48,18.48,0,0,0,1.42,1.36c.1.08.44.11.47,0,.15-.58-.43-1.25-.95-1.78a13.42,13.42,0,0,0-2.53-2,15.86,15.86,0,0,0-2.58-1.26,9.78,9.78,0,0,0-1.26-.41,4.77,4.77,0,0,0-.69-.15,1.34,1.34,0,0,0,.53-.41,11.1,11.1,0,0,1,3.06-2.11,14.72,14.72,0,0,1,7-1.69c.12,0,0-.08-.08-.09a18.38,18.38,0,0,0-3,.07,15.77,15.77,0,0,0-2.86.52,13.79,13.79,0,0,0-4.18,2.13,6.71,6.71,0,0,0-1,.85,7.24,7.24,0,0,0-3.07-2.53,17.89,17.89,0,0,0-6.63-1.88c-.11,0-.07.06,0,.09,1,.27,1.94.54,2.87.88a21.47,21.47,0,0,1,2.82,1.27c1.4.78,2.69,1.76,3,2.85.05.19.25.27.47.28v0a.2.2,0,0,0,0,.17,8.11,8.11,0,0,0-2.06.18,14.66,14.66,0,0,0-2.63.68,9.25,9.25,0,0,0-2.59,1.42,6.44,6.44,0,0,0-1.11,1.18,3,3,0,0,0-.54,1.29S344.06,339.14,344.09,339.1Z"
            />
          </g>
          <g id="elfd4d27zr4v7">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "285.268px 331.986px",
              }}
              d="M275.36,336.94a11,11,0,0,1,4.8-3.45,14,14,0,0,1,2.18-.48,10.17,10.17,0,0,0,2-.27.61.61,0,0,0,.28-.27,13.53,13.53,0,0,1,4.64,2.06,17.2,17.2,0,0,1,2,1.43c.48.44.86.94,1.41,1.36.11.08.45.11.48,0,.14-.58-.43-1.25-1-1.78a13,13,0,0,0-2.52-2,15.86,15.86,0,0,0-2.58-1.26,9.78,9.78,0,0,0-1.26-.41,6.63,6.63,0,0,0-.69-.15,1.34,1.34,0,0,0,.53-.41,11.1,11.1,0,0,1,3.06-2.11,14.59,14.59,0,0,1,7-1.68c.12,0,0-.09-.08-.1a18.44,18.44,0,0,0-3,.07,15.66,15.66,0,0,0-2.85.52,14,14,0,0,0-4.19,2.13,8,8,0,0,0-1,.85,7.21,7.21,0,0,0-3.08-2.53,18,18,0,0,0-6.62-1.88c-.12,0-.08.06,0,.09,1,.28,1.94.54,2.87.89a20.21,20.21,0,0,1,2.82,1.26c1.4.78,2.69,1.77,3,2.85.05.19.25.27.47.28v0a.2.2,0,0,0,0,.17,8,8,0,0,0-2.06.18,14.66,14.66,0,0,0-2.63.68,9.11,9.11,0,0,0-2.59,1.42,6.44,6.44,0,0,0-1.11,1.18,3,3,0,0,0-.54,1.29S275.32,337,275.36,336.94Z"
            />
          </g>
          <g id="elr24rbmw98e">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "319.586px 351.818px",
              }}
              d="M309.66,356.75a10.83,10.83,0,0,1,4.8-3.45,12.11,12.11,0,0,1,2.19-.48,10,10,0,0,0,2-.28.57.57,0,0,0,.29-.26,13.55,13.55,0,0,1,4.63,2.05,16.13,16.13,0,0,1,2,1.44,18.3,18.3,0,0,0,1.42,1.35c.1.08.44.12.47,0,.15-.59-.43-1.25-.95-1.78a12.87,12.87,0,0,0-2.52-2,16.41,16.41,0,0,0-2.59-1.27c-.4-.15-.82-.29-1.26-.41l-.69-.15a1.32,1.32,0,0,0,.53-.4A11.25,11.25,0,0,1,323,349a14.6,14.6,0,0,1,7-1.69c.12,0,0-.09-.08-.09a17.31,17.31,0,0,0-3,.07,14.71,14.71,0,0,0-2.85.52A13.51,13.51,0,0,0,319.9,350a6.13,6.13,0,0,0-1,.85,7.35,7.35,0,0,0-3.08-2.54,18.08,18.08,0,0,0-6.63-1.87c-.11,0-.07.06,0,.08,1,.28,1.94.55,2.87.89a19.72,19.72,0,0,1,2.82,1.27c1.4.78,2.69,1.76,3,2.84a.46.46,0,0,0,.47.29v0a.2.2,0,0,0,0,.17,8.12,8.12,0,0,0-2.06.17,14.66,14.66,0,0,0-2.63.69,9.24,9.24,0,0,0-2.59,1.41,6.85,6.85,0,0,0-1.11,1.19,2.86,2.86,0,0,0-.54,1.29S309.63,356.78,309.66,356.75Z"
            />
          </g>
          <g id="el9k97elvqjr">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "453.687px 243.004px",
              }}
              d="M462.36,247.82c-2-.55-4.08-1-5.66-2.48a7,7,0,0,1-1.18-1.43,4.91,4.91,0,0,0-.85-1.35.83.83,0,0,0-.41-.14,7.68,7.68,0,0,1,1.49-3.9,13.51,13.51,0,0,1,1.37-1.84c.44-.47,1-.88,1.4-1.39.07-.1,0-.36-.13-.34a3.72,3.72,0,0,0-2.06,1.18,11.67,11.67,0,0,0-1.95,2.37,9.52,9.52,0,0,0-1,2.21,6.2,6.2,0,0,0-.22,1,3.37,3.37,0,0,0,0,.54,1.58,1.58,0,0,0-.66-.26,12.84,12.84,0,0,1-3.49-1.6c-1.68-1.11-3.36-2.54-3.93-4.54,0-.09-.11,0-.1.08a8,8,0,0,0,.84,2.12,7.64,7.64,0,0,0,1.38,1.9,12.07,12.07,0,0,0,3.81,2.41,7.54,7.54,0,0,0,1.34.45,6.57,6.57,0,0,0-2.51,2.93,8.47,8.47,0,0,0-.77,5.28c0,.09.09,0,.1,0a19.77,19.77,0,0,1,.43-2.32,11.91,11.91,0,0,1,.94-2.38,6.3,6.3,0,0,1,2.93-3,.34.34,0,0,0,.25-.42h0a.85.85,0,0,0,.23,0,3.83,3.83,0,0,0,.74,1.43,8.82,8.82,0,0,0,1.54,1.69,8.4,8.4,0,0,0,2.48,1.46,10.48,10.48,0,0,0,1.81.47,6.11,6.11,0,0,0,1.81,0C462.4,248,462.42,247.83,462.36,247.82Z"
            />
          </g>
          <g id="el65icl6jj646">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "397.937px 253.098px",
              }}
              d="M406.63,257.91c-2-.55-4.08-1-5.66-2.47A6.77,6.77,0,0,1,399.8,254a5.09,5.09,0,0,0-.86-1.35.74.74,0,0,0-.41-.13,7.6,7.6,0,0,1,1.5-3.91,12.77,12.77,0,0,1,1.36-1.83c.45-.47,1-.89,1.4-1.4.08-.1,0-.35-.12-.34a3.7,3.7,0,0,0-2.07,1.19,11.41,11.41,0,0,0-2,2.37,9.52,9.52,0,0,0-1,2.21,5,5,0,0,0-.21,1,3.38,3.38,0,0,0,0,.54,1.61,1.61,0,0,0-.65-.27,12.32,12.32,0,0,1-3.5-1.6c-1.68-1.1-3.36-2.54-3.93-4.54,0-.08-.11,0-.1.09a8.23,8.23,0,0,0,.84,2.12,8.32,8.32,0,0,0,1.38,1.9,12.25,12.25,0,0,0,3.81,2.41,9.58,9.58,0,0,0,1.34.45,6.67,6.67,0,0,0-2.51,2.92,8.57,8.57,0,0,0-.77,5.29c0,.08.09,0,.1,0a18.09,18.09,0,0,1,.44-2.31,12,12,0,0,1,.93-2.39,6.24,6.24,0,0,1,2.93-3A.35.35,0,0,0,398,253h0a.41.41,0,0,0,.22,0,3.83,3.83,0,0,0,.74,1.43,9.22,9.22,0,0,0,1.54,1.7,8.77,8.77,0,0,0,2.49,1.46,10.22,10.22,0,0,0,1.81.46,6.39,6.39,0,0,0,1.8,0C406.67,258.05,406.69,257.93,406.63,257.91Z"
            />
          </g>
          <g id="el2f0jbpeyan8">
            <path
              className="animable"
              style={{
                opacity: "0.15",
                transformOrigin: "434.482px 274.528px",
              }}
              d="M443.15,279.34c-2-.55-4.08-1-5.66-2.47a6.77,6.77,0,0,1-1.17-1.44,5.09,5.09,0,0,0-.86-1.35.74.74,0,0,0-.41-.13,7.6,7.6,0,0,1,1.5-3.91,12.77,12.77,0,0,1,1.36-1.83c.44-.47,1-.89,1.4-1.4.08-.1,0-.35-.13-.34a3.68,3.68,0,0,0-2.06,1.19,11.41,11.41,0,0,0-1.95,2.37,9.52,9.52,0,0,0-1,2.21,5,5,0,0,0-.21,1,3.32,3.32,0,0,0,0,.53,1.74,1.74,0,0,0-.65-.26,12.61,12.61,0,0,1-3.5-1.6c-1.68-1.1-3.36-2.54-3.93-4.54,0-.08-.11,0-.1.09a8.23,8.23,0,0,0,.84,2.12,8.32,8.32,0,0,0,1.38,1.9,12.44,12.44,0,0,0,3.81,2.41,9.58,9.58,0,0,0,1.34.45,6.61,6.61,0,0,0-2.51,2.92,8.56,8.56,0,0,0-.77,5.29c0,.08.09,0,.1,0a18.58,18.58,0,0,1,.44-2.32,11.52,11.52,0,0,1,.93-2.38,6.24,6.24,0,0,1,2.93-3,.35.35,0,0,0,.25-.43h0a.41.41,0,0,0,.22,0,3.83,3.83,0,0,0,.74,1.43,8.85,8.85,0,0,0,1.54,1.69,8.57,8.57,0,0,0,2.49,1.47,10,10,0,0,0,1.81.46,6.39,6.39,0,0,0,1.8,0C443.19,279.48,443.21,279.36,443.15,279.34Z"
            />
          </g>
        </g>
      </g>
      <g
        className="animable"
        id="freepik--character-2--inject-16"
        style={{ transformOrigin: "375.94px 269.213px" }}
      >
        <g
          className="animable"
          id="freepik--Character--inject-16"
          style={{ transformOrigin: "375.94px 269.213px" }}
        >
          <g id="freepik--shadow--inject-16">
            <path
              className="animable"
              style={{ opacity: "0.1", transformOrigin: "364.516px 282.24px" }}
              d="M455.4,255.65c-4,3-9.54,6.11-13.6,3.2-3.54-2.53-3.16-8-1.23-11.91s5-7.3,6-11.54c2.17-9.64-7.32-18.17-9.65-27.56L415,195.22a5,5,0,0,0-6.83,1.83l-.58.55c-.45,1-.86,2-1.28,2.92-.76,1.81-1.53,3.62-2.28,5.44A161.49,161.49,0,0,0,397,225.77a32.48,32.48,0,0,0-.86,4.35,16.4,16.4,0,0,1-1.68,4.21c-1.4,3.18-2.63,6.43-3.8,9.7-2.11,5.89-4,11.86-6.32,17.69-2.16,5.49-4.66,11.43-8.18,16.21-1.7,2.3-4.77,4.2-7.11,5.79a73.09,73.09,0,0,1-8,4.7,170.11,170.11,0,0,1-17.1,7.24c-3.09,1.17-6.18,2.32-9.24,3.56A99.93,99.93,0,0,0,318,307.44a91.18,91.18,0,0,0-14.66,12.15c-4.83,4.77-9.2,10-14.31,14.48a65.17,65.17,0,0,1-19.76,11.79c-2.11.79-4.56,1.37-6.42,2.68a4.52,4.52,0,0,0-2,3.08,4.22,4.22,0,0,0,1.06,3.07,8.37,8.37,0,0,0,2.65,2,17.57,17.57,0,0,0,16.25-.19c3.26-1.8,5.9-4.62,9.28-6.2a26.44,26.44,0,0,1,5.66-1.72,3.16,3.16,0,0,1,1.8-.05c3.61,1.32-6.5,6.8-7.53,7.42-1.83,1.09-3.7,2.14-5.43,3.39-1.27.92-3.66,2.35-3.76,4.08a3.55,3.55,0,0,0,1,2.49,7.78,7.78,0,0,0,2.18,1.63,21,21,0,0,0,8.29,2.29A17.48,17.48,0,0,0,303.85,367c2.15-1.49,4-3.48,6.4-4.48s5.36-1,7.33-2.73a13.89,13.89,0,0,0,2.58-4c1.84-3.4,6.22-5.33,9.46-7.21,3.7-2.14,7.48-4.26,10.61-7.22,4.2-3.95,7-9.16,10.58-13.64,4-4.92,9.35-8.88,15.51-10.38l6.18-1.51c3.55-.87,7.09-1.84,10.66-2.6,3-.66,6.17-1.09,9.24-1.73,6.2-1.31,12.41-3.14,17.75-6.68q.86-.57,1.68-1.2c9.65-7.37,13.62-19.82,17.05-31.47,2.85,6,10.66,8.25,17.15,6.84a29.59,29.59,0,0,0,9.25-4l12.91-22.34C464.48,250.28,459.15,252.89,455.4,255.65Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--Bottom--inject-16"
            style={{ transformOrigin: "339.624px 313.005px" }}
          >
            <path
              className="animable"
              id="el1kf1wr8wg2r"
              style={{
                fill: "rgb(255, 189, 167)",
                transformOrigin: "289.271px 330.412px",
              }}
              d="M296.68,311.2s-9.4,18.28-12.9,22.59a41.5,41.5,0,0,1-9.64,9.12c-.89.63-2.83,1.74-3.56,2.25a1.29,1.29,0,0,0-.33,2c1.09,1.7,7,3.48,11,1.77s8.36-6.34,10.86-7.88a32.47,32.47,0,0,0,2.72-1.85c.85-.65.85-1.45,1.13-2.33.13-.43.36-1.62.36-1.62,1-2,11.15-13.93,12.31-15.83Z"
            />
            <path
              className="animable"
              id="ela68tu3k2gcg"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "278.194px 350.758px",
              }}
              d="M295.2,345a4.56,4.56,0,0,1-.53,1.5c-.53.74-4,1.78-5.32,2.12a7.3,7.3,0,0,0-4.41,3.1,12.62,12.62,0,0,1-7.46,4.39,20,20,0,0,1-11.82-1.18c-4.67-1.87-4.47-4.8-4.47-4.8s.3-2.74,1.59-2.92S295.2,345,295.2,345Z"
            />
            <path
              className="animable"
              id="elc90dgbhvdqa"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "279.409px 342.319px",
              }}
              d="M296.65,334.6c.12.09.34.22.35.81,0,.22-.67,2.45-.82,3.79s0,4.21-1,5.79c-3.1,2.07-7.25,1.9-9.75,4.2s-5,5.3-11.6,5.25-11-3.05-11.8-5.09.62-3.53,5.14-4.89c4.79-1.44,11.9-7.21,11.9-7.21a30.24,30.24,0,0,0,2.78-2.65,24.93,24.93,0,0,0,2.09-3.15,2.76,2.76,0,0,1,1.26-1.18,2.91,2.91,0,0,1,1.72.13,12.18,12.18,0,0,1,2.63,1,4.23,4.23,0,0,1,1.92,2c.26.62.32,1.33.64,1.92a2.44,2.44,0,0,0,2.26,1.24,2.12,2.12,0,0,0,2-1.38S296.65,334.6,296.65,334.6Z"
            />
            <path
              className="animable"
              id="eloijh69048cc"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "270.012px 349.163px",
              }}
              d="M278.27,353.78a8.22,8.22,0,0,0-3.28-7.85c-4.28-3.43-7.51-2.45-9.19-1.7-2,.89-5,3-3.9,5.21,1.21,2.39,3.62,3.9,8.49,5A11.89,11.89,0,0,0,278.27,353.78Z"
            />
            <path
              className="animable"
              id="elr7ueie5ikq"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "284.59px 337.579px",
              }}
              d="M287.87,340.3a.55.55,0,0,1-.39-.32c-.39-.86-3.28-4.41-6.84-4.16-.09-.43.28-.77,1.05-1,3.6.41,6.35,3.75,6.82,4.8a.53.53,0,0,1-.29.7A.6.6,0,0,1,287.87,340.3Z"
            />
            <path
              className="animable"
              id="elttb1fgqhhs"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "282.005px 339.733px",
              }}
              d="M278.2,338a1.71,1.71,0,0,1,1.19-1,10.3,10.3,0,0,1,6.37,4.74.51.51,0,0,1-.29.7.6.6,0,0,1-.35,0,.59.59,0,0,1-.39-.32C284.36,341.28,281.61,337.92,278.2,338Z"
            />
            <path
              className="animable"
              id="elqt296yene5"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "276.058px 343.955px",
              }}
              d="M271.8,342.31a3.13,3.13,0,0,1,1.8-1.11,10.16,10.16,0,0,1,6.67,4.78.52.52,0,0,1-.29.7.54.54,0,0,1-.35,0,.55.55,0,0,1-.39-.32C278.83,345.48,275.63,341.58,271.8,342.31Z"
            />
            <path
              className="animable"
              id="elnremq1wxq2p"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "279.167px 341.835px",
              }}
              d="M282.37,344.57a.56.56,0,0,1-.38-.31c-.39-.86-3.23-4.33-6.72-4.17a1.91,1.91,0,0,1,1.37-1,10.23,10.23,0,0,1,6.38,4.74.52.52,0,0,1-.3.7A.59.59,0,0,1,282.37,344.57Z"
            />
            <path
              className="animable"
              id="elxt5oj81yxu"
              style={{
                fill: "rgb(255, 189, 167)",
                transformOrigin: "310.4px 342.877px",
              }}
              d="M317.87,324.39s-10,16.62-13.47,20.93a43.93,43.93,0,0,1-9.95,9.32c-.89.63-2.83,1.74-3.55,2.25a1.28,1.28,0,0,0-.34,2c1.09,1.71,7,3.49,11,1.78s8.36-6.34,10.86-7.89a30.23,30.23,0,0,0,2.72-1.85c.85-.64.86-1.44,1.13-2.32.13-.43.36-1.63.36-1.63,1-2,12.1-12.36,13.95-14.52Z"
            />
            <path
              className="animable"
              id="el6v7ftw963xn"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "298.519px 362.475px",
              }}
              d="M315.51,356.72a4.64,4.64,0,0,1-.53,1.5c-.53.73-4,1.77-5.32,2.11a7.35,7.35,0,0,0-4.41,3.1,12.6,12.6,0,0,1-7.46,4.4A20,20,0,0,1,286,366.64c-4.67-1.86-4.47-4.8-4.47-4.8s.3-2.74,1.59-2.91S315.51,356.72,315.51,356.72Z"
            />
            <path
              className="animable"
              id="el39xmr8fypyg"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "299.759px 354.044px",
              }}
              d="M317,346.33c.12.09.34.22.35.81,0,.22-.67,2.45-.82,3.79s0,4.21-1,5.79c-3.1,2.07-7.25,1.9-9.75,4.2s-5,5.3-11.6,5.25-11-3.05-11.8-5.1.62-3.52,5.14-4.88c4.79-1.44,11.9-7.21,11.9-7.21a30.24,30.24,0,0,0,2.78-2.65,25,25,0,0,0,2.09-3.16,2.87,2.87,0,0,1,1.26-1.18,2.91,2.91,0,0,1,1.72.13,12.76,12.76,0,0,1,2.63,1,4.19,4.19,0,0,1,1.92,2c.26.62.32,1.32.64,1.92a2.46,2.46,0,0,0,2.26,1.24,2.11,2.11,0,0,0,2-1.39S317,346.33,317,346.33Z"
            />
            <path
              className="animable"
              id="el5kfpdsvcwws"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "290.322px 360.886px",
              }}
              d="M298.58,365.5a8.22,8.22,0,0,0-3.28-7.85c-4.28-3.43-7.51-2.45-9.19-1.7-2,.9-5,3-3.9,5.22,1.21,2.39,3.62,3.9,8.49,5A11.89,11.89,0,0,0,298.58,365.5Z"
            />
            <path
              className="animable"
              id="elqive2mo4gi8"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "304.901px 349.268px",
              }}
              d="M308.18,352a.57.57,0,0,1-.39-.32c-.39-.87-3.28-4.41-6.84-4.17-.09-.42.28-.76,1.05-1,3.6.41,6.35,3.74,6.82,4.79a.52.52,0,0,1-.29.7A.61.61,0,0,1,308.18,352Z"
            />
            <path
              className="animable"
              id="elbxh14vicqsi"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "302.313px 351.403px",
              }}
              d="M298.51,349.67a1.7,1.7,0,0,1,1.19-1,10.23,10.23,0,0,1,6.37,4.74.52.52,0,0,1-.29.7.6.6,0,0,1-.35,0,.58.58,0,0,1-.39-.31C304.67,353,301.92,349.65,298.51,349.67Z"
            />
            <path
              className="animable"
              id="elc93mx3ko05d"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "296.368px 355.655px",
              }}
              d="M292.11,354a3.17,3.17,0,0,1,1.8-1.1c3.52.48,6.21,3.75,6.67,4.78a.52.52,0,0,1-.29.7.53.53,0,0,1-.35,0,.56.56,0,0,1-.39-.31C299.14,357.2,295.94,353.31,292.11,354Z"
            />
            <path
              className="animable"
              id="elyhkqftrubwa"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "299.477px 353.559px",
              }}
              d="M302.68,356.3a.55.55,0,0,1-.38-.32c-.39-.86-3.23-4.32-6.72-4.17a1.9,1.9,0,0,1,1.37-1,10.26,10.26,0,0,1,6.38,4.73.52.52,0,0,1-.3.7A.53.53,0,0,1,302.68,356.3Z"
            />
            <path
              className="animable"
              id="elzbgm0194dt"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "344.855px 290.515px",
              }}
              d="M396.27,257.78c-.09,7.15-.09,12.71-3.85,19.22s-11,10.22-21.81,13.83c-8.94,3-32.21,4.06-36,4.75-2.62.48-5.67.76-7.44,4.43-2,4.19-2.5,4.61-7.84,10-6.92,6.93-8.45,8.37-13.54,13.06-3.5,1.13-10.41-3.3-12.35-6.75,0,0,15.19-28.29,19.11-33.35,4.18-5.4,28.3-13,39.44-16.28,3.71-1.1,23.46-5.15,23.46-5.15Z"
            />
            <path
              className="animable"
              id="el9br91mgqv98"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "344.855px 290.515px",
              }}
              d="M396.27,257.78c-.09,7.15-.09,12.71-3.85,19.22s-11,10.22-21.81,13.83c-8.94,3-32.21,4.06-36,4.75-2.62.48-5.67.76-7.44,4.43-2,4.19-2.5,4.61-7.84,10-6.92,6.93-8.45,8.37-13.54,13.06-3.5,1.13-10.41-3.3-12.35-6.75,0,0,15.19-28.29,19.11-33.35,4.18-5.4,28.3-13,39.44-16.28,3.71-1.1,23.46-5.15,23.46-5.15Z"
            />
            <path
              className="animable"
              id="elg21hhxp75d7"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "357.09px 288.685px",
              }}
              d="M334.65,295.58c3.75-.69,27-1.77,36-4.75h0c10.79-3.61,18.05-7.32,21.81-13.83.29-.5.55-1,.79-1.48l.17-.33v0c.2-.41.38-.81.55-1.22l0-.08.06-.14a25.34,25.34,0,0,0,1-3L376,267.17a35,35,0,0,0,1,11.12s-28.64,7.1-34.26,9.23c-6.61,2.5-15.11,3.81-16.46,9.52-.78,3.28-2.39,7.37-7.13,13.16l.23-.22c5.34-5.36,5.81-5.78,7.84-10C329,296.34,332,296.06,334.65,295.58Z"
            />
            <path
              className="animable"
              id="ell9lv1gm0kf"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "366.89px 298.99px",
              }}
              d="M315.72,326.88c2.93,6.26,11.72,8.75,11.72,8.75s5.55-4.82,12.75-11.45c4.27-3.94,5.65-6.59,8.15-10.52,2.19-3.46,5.31-3.12,7.91-3.68s26.8-2.79,36-4.85c8.2-1.83,13.89-4.82,18.64-10.66a23.45,23.45,0,0,0,1.42-1.9c2.62-3.85,4.23-8.52,5.75-16.59l-32.71-10.4-9.9-3.16-.24-.07c.05,1,.7,4.24.89,5.32a54.31,54.31,0,0,0,4.28,12.71s0,0,0,0-39.27,9.38-44.84,16.59C331.61,302.05,315.72,326.88,315.72,326.88Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--Top--inject-16"
            style={{ transformOrigin: "421.723px 227.323px" }}
          >
            <path
              className="animable"
              id="elztgov7vkc2m"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "413.974px 207.851px",
              }}
              d="M403.06,170.84c3.49-2.06,13.83-4.73,22.3,1.7s7.94,15.73,8.1,26.88c.11,7.58,1.45,16.56,4.93,23,3.79,7,5.22,14.82-1.55,20.28s-25.19,5.16-32.49,3.26-21-8.73-17.38-21.18,9.69-10.54,11-19.33S403.06,170.84,403.06,170.84Z"
            />
            <path
              className="animable"
              id="el2h65mycmbjo"
              style={{
                fill: "rgb(255, 189, 167)",
                transformOrigin: "377.488px 218.493px",
              }}
              d="M367.71,213.89a18.14,18.14,0,0,1,.73-2.69c1.41-4.24.83-8.79,0-13.08-.15-.74-.31-1.47-.47-2.2a10,10,0,0,1-.19-1.07c0-.35-.07-.63-.49-.72a1.28,1.28,0,0,0-.88.21,3.67,3.67,0,0,0-1.55,2.52,19.28,19.28,0,0,0-.13,3c0,.78-.71.24-1-.06-1.45-1.49-2.18-4.72-2.64-6.71a27.55,27.55,0,0,0-.87-3.93,4.08,4.08,0,0,0-1.49-1.95c-.47-.31-1-.44-1.34.19a2.93,2.93,0,0,0-.18,1.29,3.06,3.06,0,0,1-.73,2.39,7,7,0,0,0-1.27,1.29,22.36,22.36,0,0,0-.7,2.19c-.28.63-.86,1-1.2,1.56a5.87,5.87,0,0,0-.35,2.33,18.71,18.71,0,0,0,.45,4.84,35.12,35.12,0,0,0,2.46,7A9.72,9.72,0,0,1,357,214.2a21.12,21.12,0,0,1-.53,4.1c-.34,1.69-.57,3.41-1,5.06-4.21,14.68-3.52,17.31-1.28,23.13.79,2,3.92,5.42,11.39,2.26,8.27-3.49,25.85-14.24,25.85-14.24l11.14-19.17a36.57,36.57,0,0,0-5.3-1.07c-2.71-.34-6.29,1-9.17,3-5.95,4.12-21.36,14.85-21.36,14.85S367.48,216.37,367.71,213.89Z"
            />
            <path
              className="animable"
              id="el6v662lseisr"
              style={{
                fill: "rgb(240, 153, 122)",
                transformOrigin: "362.858px 206.52px",
              }}
              d="M363.81,202.84a13.4,13.4,0,0,0-1.27,7.36,7.83,7.83,0,0,1-.58-4C362.35,204.11,363,203.39,363.81,202.84Z"
            />
            <path
              className="animable"
              id="ele4l9vj6yfbr"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "384.605px 231.509px",
              }}
              d="M402.52,215.16c-2.33-.64-4.68-1.95-9.57-.64s-23.66,15.22-24.61,15.56l-1.58.6-.07,1.43s2.61,5.92,2.09,9.9a15,15,0,0,1-2.09,6.23,2.5,2.5,0,0,0,2.7.67c1.67-.57,3.47-2.43,5-3.27s20.34-11.72,20.34-11.72Z"
            />
            <path
              className="animable"
              id="elk27majeapye"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "365.244px 241.02px",
              }}
              d="M366.69,232.11c1.3,1.69,4.47,9.25,0,16.13a15.43,15.43,0,0,1-5.2,1.69c2.22-1.61,5.73-7.06,5.2-16.45Z"
            />
            <path
              className="animable"
              id="elcytazm7bayf"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "402.814px 250.645px",
              }}
              d="M417.66,218.19l8.62,3.21s3.7,2.26,3.82,13.11A55.22,55.22,0,0,1,428.72,249c-4.06,22.48-13.22,37.15-13.22,37.15a106.46,106.46,0,0,1-23.34-10c-13.11-7.57-16.67-14.62-16.67-14.62l10-8,2.62-12s-4.82-5.28-2.47-11.39c3.26-8.47,16.89-15,16.89-15Z"
            />
            <path
              className="animable"
              id="elbti82v9g0zq"
              style={{
                fill: "rgb(255, 189, 167)",
                transformOrigin: "412.058px 204.37px",
              }}
              d="M398.71,176.72c-1.18,1.07-5.34,5.14-5.35,18.44,0,11.39,3.18,14.1,4.95,15s4.65.91,8.12.6l-.42,5.48s-16.47,11.92-6.47,15.29,21.28-11.76,21.28-11.76L422,203.67s1.86,2.11,5.52-.62c3-2.26,4.28-6.35,2.25-8.75a4.93,4.93,0,0,0-7.95,1s-8.05-3.32-6.13-16.43C408.87,179.47,402.52,179.5,398.71,176.72Z"
            />
            <path
              className="animable"
              id="elznq5ngdi8vr"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "407.622px 193.154px",
              }}
              d="M406.21,193a1.42,1.42,0,1,0,2.82.35,1.44,1.44,0,0,0-1.22-1.63A1.45,1.45,0,0,0,406.21,193Z"
            />
            <path
              className="animable"
              id="elk8nfipirda"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "398.307px 187.685px",
              }}
              d="M399.92,186.52l-3.3,1.11a1.67,1.67,0,0,0,2.15,1.13A1.83,1.83,0,0,0,399.92,186.52Z"
            />
            <path
              className="animable"
              id="eli2smobqrvji"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "409.014px 188.62px",
              }}
              d="M410.62,189.26l-2.86-2a1.67,1.67,0,0,0,.37,2.4A1.83,1.83,0,0,0,410.62,189.26Z"
            />
            <path
              className="animable"
              id="el3vgc25jz40w"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "396.879px 192.007px",
              }}
              d="M395.48,191.8a1.42,1.42,0,1,0,2.81.35,1.43,1.43,0,0,0-1.22-1.63A1.45,1.45,0,0,0,395.48,191.8Z"
            />
            <path
              className="animable"
              id="el9do1g20xh6d"
              style={{
                fill: "rgb(240, 153, 122)",
                transformOrigin: "412.66px 208.685px",
              }}
              d="M406.43,210.8a22.45,22.45,0,0,0,8.5-2.41,10.2,10.2,0,0,0,4.13-4.07,8.5,8.5,0,0,1-3.37,5.33c-3.46,2.81-9.43,3.4-9.43,3.4Z"
            />
            <path
              className="animable"
              id="el6mm7vcix47m"
              style={{
                fill: "rgb(240, 153, 122)",
                transformOrigin: "404.99px 203.43px",
              }}
              d="M406.61,203.43a1.62,1.62,0,1,1-1.61-1.62A1.62,1.62,0,0,1,406.61,203.43Z"
            />
            <path
              className="animable"
              id="elmvxpxlyau8n"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "405.498px 177.748px",
              }}
              d="M408.41,169c-6.11-1.47-12.23,1.23-15.05,5.49a15.09,15.09,0,0,0-2.21,9.47l5.53,1.05a20.45,20.45,0,0,1,1.94-6.52,16.9,16.9,0,0,0-.25,7s3.86.65,8.6,1.07a23.2,23.2,0,0,1,1.51-6.88,28,28,0,0,0,0,7c2.18.12,6.09.29,7.91.19l3.53-13S412.84,170,408.41,169Z"
            />
            <path
              className="animable"
              id="elnhxtd7s418a"
              style={{
                fill: "rgb(255, 189, 167)",
                transformOrigin: "456.337px 247.926px",
              }}
              d="M490.35,241.72a4.19,4.19,0,0,0-2.43-.26,26.53,26.53,0,0,0-3.83,1.29c-1.95.62-5.07,1.67-7.1,1.19-.41-.09-1.25-.43-.59-.84a15.36,15.36,0,0,0,2.54-1.69,3.6,3.6,0,0,0,1.37-2.6,1.41,1.41,0,0,0-.26-.88c-.3-.3-.56-.19-.88,0a7.85,7.85,0,0,1-1,.38c-.72.25-1.42.49-2.12.75-4.12,1.46-8.31,3.32-11.24,6.72a18.15,18.15,0,0,1-1.91,2c-2,1.48-18.27,8.79-18.27,8.79s-5.92-17.82-8.23-24.69c-1.11-3.3-2.84-6.77-5.21-8.11a17.66,17.66,0,0,0-4.35-1.86c-6.09,7.08-6.28,14.13-3.42,21.81,0,0,7.65,19.12,12.17,26.87a14.39,14.39,0,0,0,1,1.47.13.13,0,0,0,.05.07c1.46,1.91,4,2.66,9.07.5,3.33-1.42,7.71-4.13,13.54-8.63,2.06-1.57,7.74-6.15,8.95-6.88a10.09,10.09,0,0,1,3.95-1,34.44,34.44,0,0,0,7.22-1.5,17.5,17.5,0,0,0,4.38-2.1,6.06,6.06,0,0,0,1.83-1.5,13.7,13.7,0,0,1,.71-1.84c.42-.63,1.16-1,1.51-1.71a6.66,6.66,0,0,0,.46-1.78,3,3,0,0,1,1.66-1.84,2.83,2.83,0,0,0,1-.82C491.24,242.37,490.87,242,490.35,241.72Z"
            />
            <path
              className="animable"
              id="el84zdiaapzxj"
              style={{
                fill: "rgb(240, 153, 122)",
                transformOrigin: "471.53px 247.83px",
              }}
              d="M474.35,245.39a13.4,13.4,0,0,1-5.64,4.88,7.85,7.85,0,0,0,3.73-1.57C474,247.29,474.3,246.35,474.35,245.39Z"
            />
            <path
              className="animable"
              id="el73qcqu16oj3"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "432.853px 243.572px",
              }}
              d="M426.28,221.4c4,1.23,6.19,2.23,8.19,5.25s7.56,21,8.72,23.82,2.76,4.28,1.43,6.06c0,0-8.7,3.37-11.67,9-2.5,1.05-2-2-2.84-3.79s-8.5-20.24-8.5-20.24S417.32,228.39,426.28,221.4Z"
            />
            <path
              className="animable"
              id="elfjpoag8ntru"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "438.81px 263.11px",
              }}
              d="M444.62,256.53a31,31,0,0,0-7.78,8.16,13,13,0,0,0-1.74,5L433,265.57S434.1,259.86,444.62,256.53Z"
            />
            <path
              className="animable"
              id="elbpphdzg9lw7"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "408.522px 224.155px",
              }}
              d="M409.51,222l-7,6.26L406,216.28s-16.51,11.89-6.51,15.26,21.28-11.77,21.28-11.77l0-.44Z"
            />
            <path
              className="animable"
              id="elj9zvdiqll5"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "413.155px 222.459px",
              }}
              d="M402.48,228.23s5.58-6.72,7.06-7.73,6.83,1.23,11.45-3l.17-2.34s.52-.13,1.18,1.55l1.49,3.78s-.2,3.61-4.38,6.39c-5.07,3.38-7.59,3.77-8.34,1.25a20.66,20.66,0,0,0-2-4.7Z"
            />
            <path
              className="animable"
              id="el79mrtgubz3u"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "402.226px 220.805px",
              }}
              d="M402.48,228.23,406,216.28l.25-2.88c-.71-.18-1.41.88-2.35,2s-6.41,6.34-5.62,8.72a8.18,8.18,0,0,1,4.4-2.7Z"
            />
            <g id="elz0vuemt9mj">
              <path
                className="animable"
                style={{
                  opacity: "0.1",
                  transformOrigin: "384.605px 231.509px",
                }}
                d="M402.52,215.16c-2.33-.64-4.68-1.95-9.57-.64s-23.66,15.22-24.61,15.56l-1.58.6-.07,1.43s2.61,5.92,2.09,9.9a15,15,0,0,1-2.09,6.23,2.5,2.5,0,0,0,2.7.67c1.67-.57,3.47-2.43,5-3.27s20.34-11.72,20.34-11.72Z"
              />
            </g>
            <g id="elwtdv1gosq3">
              <path
                className="animable"
                style={{
                  opacity: "0.1",
                  transformOrigin: "432.853px 243.572px",
                }}
                d="M426.28,221.4c4,1.23,6.19,2.23,8.19,5.25s7.56,21,8.72,23.82,2.76,4.28,1.43,6.06c0,0-8.7,3.37-11.67,9-2.5,1.05-2-2-2.84-3.79s-8.5-20.24-8.5-20.24S417.32,228.39,426.28,221.4Z"
              />
            </g>
            <polygon
              className="animable"
              id="el268f2m446j5"
              style={{
                fill: "rgb(240, 153, 122)",
                transformOrigin: "400.23px 194.9px",
              }}
              points="403.06 190.38 402.2 199.42 397.4 197.87 403.06 190.38"
            />
          </g>
        </g>
      </g>
      <g
        className="animable"
        id="freepik--character-1--inject-16"
        style={{ transformOrigin: "131.379px 296.524px" }}
      >
        <g
          className="animable"
          id="freepik--character-on-the-couch--inject-16"
          style={{ transformOrigin: "131.379px 296.524px" }}
        >
          <g
            className="animable"
            id="freepik--Couch--inject-16"
            style={{ transformOrigin: "124.79px 306.479px" }}
          >
            <path
              className="animable"
              id="elvgua6obift"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "114.3px 397.62px",
              }}
              d="M120,391.05h-11.4l1.82,11.11h0a2,2,0,0,0,1.11,1.37,6.06,6.06,0,0,0,5.5,0,2,2,0,0,0,1.11-1.37h0Z"
            />
            <path
              className="animable"
              id="elzmsrx13pwdk"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "51.205px 363.71px",
              }}
              d="M56.9,357.14H45.51l1.82,11.11h0a2,2,0,0,0,1.1,1.37,6.08,6.08,0,0,0,5.51,0,2.07,2.07,0,0,0,1.11-1.37h0Z"
            />
            <path
              className="animable"
              id="elj8qpqf6wdd"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "199.615px 348.37px",
              }}
              d="M205.31,341.8H193.92l1.82,11.11h0a2,2,0,0,0,1.11,1.37,6.08,6.08,0,0,0,5.51,0,2,2,0,0,0,1.1-1.37h0Z"
            />
            <path
              className="animable"
              id="els41d9i6yal"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "140.21px 316.255px",
              }}
              d="M145.91,309.68h-11.4l1.82,11.12h0a2,2,0,0,0,1.1,1.37,6.08,6.08,0,0,0,5.51,0,2.07,2.07,0,0,0,1.11-1.37h0Z"
            />
            <path
              className="animable"
              id="elhuzfb06tcl"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "124.79px 304.534px",
              }}
              d="M213,285v53.06a12.25,12.25,0,0,1-5.53,9.57l-4.5,2.6-.08,0a12.45,12.45,0,0,1-6.9,1.18l-67.62,35.79a12.33,12.33,0,0,1-5.46,9.18.07.07,0,0,0,0,0L118.32,399a2.06,2.06,0,0,1-.42.21l-.23.12-.07,0a12.53,12.53,0,0,1-8.57.4,7.89,7.89,0,0,1-1-.36l-.15-.06c-.23-.1-.45-.22-.65-.33L42.19,361.57A12.26,12.26,0,0,1,36.67,352l-.09-67.18v-23.3A12.28,12.28,0,0,1,42.09,252L114.87,210a11.42,11.42,0,0,1,10.66.18l4.5,2.59a14.69,14.69,0,0,1,6.37,9.52l4.34,26.19,4-2.31a12,12,0,0,1,12,0l50.66,29.26A12.24,12.24,0,0,1,213,285Z"
            />
            <path
              className="animable"
              id="elww8natvh02"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "84.47px 235.534px",
              }}
              d="M130,212.79l-4.5-2.6a11.43,11.43,0,0,0-10.66-.18L42.1,252c-.32.19-.68.43-.57.35a12.69,12.69,0,0,0-4.9,8.28c.41-2.82,2.71-3.84,5.46-2.25l4.51,2.6a12.22,12.22,0,0,0,11,0L130,219.17C133.08,217.4,133.08,214.55,130,212.79Z"
            />
            <path
              className="animable"
              id="el1gqr0nqz0ql"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "174.13px 298.038px",
              }}
              d="M213,285v53.06a12.25,12.25,0,0,1-5.53,9.57l-4.5,2.6-.08,0a11.78,11.78,0,0,1-6.46,1.22,10.82,10.82,0,0,1-4.51-1.26l-51.13-29.54a12.24,12.24,0,0,1-5.53-9.57V258.06a12.22,12.22,0,0,1,5.53-9.57l4-2.31a12,12,0,0,1,12,0l50.66,29.26A12.24,12.24,0,0,1,213,285Z"
            />
            <path
              className="animable"
              id="eljwvek426u8m"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "175.725px 297.764px",
              }}
              d="M144.75,246.17l-4,2.32c-3,1.76-3,4.63,0,6.38l51.14,29.53A12.25,12.25,0,0,1,197.4,294V347c0,3.51,2.48,5,5.52,3.19l4.5-2.59a12.27,12.27,0,0,0,5.53-9.57V285a12.27,12.27,0,0,0-5.53-9.57l-50.66-29.25A12,12,0,0,0,144.75,246.17Z"
            />
            <path
              className="animable"
              id="elz40qyc5ebie"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "204.36px 315.262px",
              }}
              d="M197.4,294V347c0,3.51,2.48,5,5.52,3.19l4.5-2.59a12.27,12.27,0,0,0,5.53-9.57V285a11.32,11.32,0,0,0-1.63-5.44l-15.55,9A11.25,11.25,0,0,1,197.4,294Z"
            />
            <path
              className="animable"
              id="elr1pv1wdw5qf"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "133.105px 348.335px",
              }}
              d="M195.1,351.49a12.87,12.87,0,0,1-2,3,23.8,23.8,0,0,1-5.2,3.64c-19.43,11.22-33.44,19.28-52.87,30.5a6.12,6.12,0,0,1-5.53,0l-18-10.38L75.58,357.55c-3-1.76-5.53-5.87-5.53-9.18s2.48-7.41,5.53-9.17L96,327.42l15.56-9,16.89-9.72a12.22,12.22,0,0,1,11.05,0l51.13,29.53c3,1.76,5.53,5.87,5.53,9.18A9.73,9.73,0,0,1,195.1,351.49Z"
            />
            <path
              className="animable"
              id="el3dn1fitodw2"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "164.175px 365.834px",
              }}
              d="M135,376.7,193.36,343c1.52-.88,2.76-.17,2.76,1.59v5.59a6.13,6.13,0,0,1-2.76,4.79L135,388.67c-1.53.88-2.77.16-2.77-1.6v-5.58A6.09,6.09,0,0,1,135,376.7Z"
            />
            <path
              className="animable"
              id="ellx2l9f456a"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "133.085px 326.519px",
              }}
              d="M128.41,281.36,75.58,311.83a12.2,12.2,0,0,0-5.53,9.57v11.18a12.22,12.22,0,0,0,5.53,9.57l51.14,29.52a12.16,12.16,0,0,0,11.05,0L190.6,341.2a12.2,12.2,0,0,0,5.52-9.56V320.46a12.2,12.2,0,0,0-5.52-9.57l-51.15-29.53A12.2,12.2,0,0,0,128.41,281.36Z"
            />
            <path
              className="animable"
              id="elssdy6g2git8"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "101.15px 342.596px",
              }}
              d="M132.25,349.05V373a11.28,11.28,0,0,1-5.53-1.33L75.58,342.15a12.22,12.22,0,0,1-5.53-9.57V321.4a12.37,12.37,0,0,1,5-9.21c-2.47,1.78-2.28,4.38.57,6l51.14,29.53A11.3,11.3,0,0,0,132.25,349.05Z"
            />
            <path
              className="animable"
              id="ele1s4k0g2j0c"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "133.086px 314.555px",
              }}
              d="M137.77,347.74l52.83-30.47c3.05-1.77,3.05-4.62,0-6.38l-51.15-29.53a12.2,12.2,0,0,0-11,0L75.58,311.83c-3.06,1.76-3.06,4.62,0,6.38l51.14,29.53A12.22,12.22,0,0,0,137.77,347.74Z"
            />
          </g>
          <g
            className="animable"
            id="freepik--character--inject-16"
            style={{ transformOrigin: "151.08px 296.524px" }}
          >
            <g
              className="animable"
              id="freepik--Legs--inject-16"
              style={{ transformOrigin: "156.129px 351.485px" }}
            >
              <path
                className="animable"
                id="elfkkilwqmdsp"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "171.624px 364.44px",
                }}
                d="M178.42,376.3c-.69-9.39,5.7-33.64,5.7-33.64l-17.35-10.21s-.79,5.92-1.78,13.89-2.74,11.21-2.74,11.21-3.22,4.11-3.12,6.8,2.46,8.85,3.88,13.59,2.33,8.4,5.19,13,15.2,7.89,14.51,3.24C181.74,387.68,179.2,384,178.42,376.3Z"
              />
              <path
                className="animable"
                id="eljrmib2plie"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "171.008px 378.159px",
                }}
                d="M162.25,357.55c-1-.05-2.19,1.73-3,3s-3,2.28-2.56,5.54,3.33,5.69,3.87,10.14.76,12.11,7.32,17.47,13.41,5.82,15.91,4.34a3.21,3.21,0,0,0,1.53-1.95,2.61,2.61,0,0,0-.41-2.07q-1.16-2.48-2.12-5a68.65,68.65,0,0,1-3.32-10.67c-.47-2.36-.57-4.54-1.17-4.91a9.34,9.34,0,0,0-4.86-1.53c-2.57-.34-4-.25-4.38,0s-.37,1.05-.41,1.6c-.06.76-.12,1.51-.19,2.26a1.22,1.22,0,0,1-.11.5.43.43,0,0,1-.42.24.61.61,0,0,1-.38-.39c-1.22-2.57-1.65-5.43-2.35-8.19a28.71,28.71,0,0,0-1.75-4.91c-.44-1-1.11-2.46-1.44-3.39a2,2,0,0,1,0-1.5Z"
              />
              <path
                className="animable"
                id="elqynnws0w5xh"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "197.955px 397.436px",
                }}
                d="M192.66,377.94s5.39,12.91,8.44,17.65a56,56,0,0,0,11.47,13.34c1,.86,3.35,2.38,4.2,3.07a1.59,1.59,0,0,1,.26,2.45c-1.48,2-8.93,3.72-13.7,1.29s-10-7.72-12.91-9.82l-3.9-2.81c-1-.72-.93-1.17-.82-2.38l-.5-1.94c-.78-4-6.78-12.71-6.78-12.71Z"
              />
              <path
                className="animable"
                id="eluvbk8bzdxz"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "205.148px 412.14px",
                }}
                d="M185.2,398.79c-.88.54-.83,2.66-.79,4.21s-1.15,3.56,1,6,6,2.8,8.93,6.16,7.5,9.54,15.94,10.24,14.35-2.8,15.57-5.45a3.21,3.21,0,0,0,.15-2.47c-.3-.84-.77-1-1.51-1.48q-2.36-1.38-4.59-2.92a70,70,0,0,1-8.79-6.91c-1.72-1.68-3-3.41-3.75-3.39a9.41,9.41,0,0,0-4.87,1.5c-2.3,1.17-3.42,2.06-3.61,2.46-.26.55.29,1.08.57,1.56l1.12,2a1.22,1.22,0,0,1,.2.47.45.45,0,0,1-.22.44.64.64,0,0,1-.53-.11c-2.46-1.43-4.44-3.54-6.58-5.41a23.48,23.48,0,0,0-3.77-2.9c-.95-.59-2.16-1.2-3.11-1.8-.71-.44-1-.62-1.07-1Z"
              />
              <path
                className="animable"
                id="elqg9zqn2zwk"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "142.14px 336.216px",
                }}
                d="M184.86,355.77c.78-6.51,1.95-16.46,2.64-23.1,1.11-10.6,1.65-21.61-.47-26.24-2-4.37-11.62-9.69-21.73-15.12s-28-13.83-28-13.83L86.08,288.21c1.64,8.92,2.35,13.28,7.26,21.06,4.76,7.52,11.11,12.13,23.36,17.72,11,5,24,10.34,26.87,11.61,3.64,1.61,7,2.82,9,8.27,1.84,5.19,4.43,14.3,11.65,25l15.63,23.07s12.28.71,18.35-9.24C198.16,385.67,191.77,371.17,184.86,355.77Z"
              />
              <path
                className="animable"
                id="el6oaeu4ee4j5"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "187.415px 387.985px",
                }}
                d="M176.29,390.2l3,5s14.71,1.41,19.25-9.49l-2.28-5C194.18,386.85,183.51,391.33,176.29,390.2Z"
              />
              <g id="elto21r12mi1">
                <path
                  className="animable"
                  style={{
                    opacity: "0.3",
                    transformOrigin: "142.14px 336.216px",
                  }}
                  d="M184.86,355.77c.78-6.51,1.95-16.46,2.64-23.1,1.11-10.6,1.65-21.61-.47-26.24-2-4.37-11.62-9.69-21.73-15.12s-28-13.83-28-13.83L86.08,288.21c1.64,8.92,2.35,13.28,7.26,21.06,4.76,7.52,11.11,12.13,23.36,17.72,11,5,24,10.34,26.87,11.61,3.64,1.61,7,2.82,9,8.27,1.84,5.19,4.43,14.3,11.65,25l15.63,23.07s12.28.71,18.35-9.24C198.16,385.67,191.77,371.17,184.86,355.77Z"
                />
              </g>
              <g id="el0h96b2j7z9kq">
                <path
                  className="animable"
                  style={{
                    opacity: "0.15",
                    transformOrigin: "158.33px 319.48px",
                  }}
                  d="M183.23,352.14c-6.49-14.43-13-28.7-14.8-31.73-3.79-6.43-34-23.25-35-23.78h0l1.25-2a19.47,19.47,0,0,0,2.39-7.81,20.79,20.79,0,0,1-.78,8.75c4.65,2.7,16.48,9.57,21.23,12.51,6,3.7,12.35,8.22,15.27,15C175,328.08,180.51,344.15,183.23,352.14Z"
                />
              </g>
            </g>
            <g
              className="animable"
              id="freepik--Arm--inject-16"
              style={{ transformOrigin: "144.243px 252.492px" }}
            >
              <path
                className="animable"
                id="eln9nlj5pjak"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "144.325px 252.639px",
                }}
                d="M112.29,219.27c11.5-1.06,14.33,3.6,17.12,8.21,4.72,7.81,13.55,32.68,13.55,32.68l33.4,15.14-5.84,10.86s-31.33-9.22-35.68-11.16c-2.69-1.2-4.18-2-6.19-5.68-4-7.28-10.34-21.14-10.34-21.14Z"
              />
              <path
                className="animable"
                id="ela1yjui8edr8"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "131.143px 248.377px",
                }}
                d="M112.29,219.06c3.39-.54,8.4-.26,11.94,2s5,4.91,9.21,13.42S143.3,260,143.3,260l6.86,3.39c-2.89,1.22-8.08,10.45-6.89,14.54,0,0-7.55-2.39-10.33-3.25s-3.49-2.76-5.75-6.91-9.48-19.89-9.48-19.89S111,219.57,112.29,219.06Z"
              />
              <g id="el0posj3fgjyvb">
                <path
                  className="animable"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: "0.7",
                    transformOrigin: "131.143px 248.377px",
                  }}
                  d="M112.29,219.06c3.39-.54,8.4-.26,11.94,2s5,4.91,9.21,13.42S143.3,260,143.3,260l6.86,3.39c-2.89,1.22-8.08,10.45-6.89,14.54,0,0-7.55-2.39-10.33-3.25s-3.49-2.76-5.75-6.91-9.48-19.89-9.48-19.89S111,219.57,112.29,219.06Z"
                />
              </g>
              <g id="eltr39cvd30z7">
                <path
                  className="animable"
                  style={{
                    opacity: "0.15",
                    transformOrigin: "138.83px 260.59px",
                  }}
                  d="M143.3,260c-1.65-.4-6.17.76-8.94,2.67,0,0,2.12-3.53,8.44-4.16Z"
                />
              </g>
            </g>
            <g
              className="animable"
              id="freepik--Chest--inject-16"
              style={{ transformOrigin: "108.119px 258.467px" }}
            >
              <path
                className="animable"
                id="elzr9hv0zy9ak"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "108.119px 258.467px",
                }}
                d="M91.41,223.27l-11.77,4.5c-2.33,1.07,1.88,15,2.92,31.37,1.06,16.8,4.26,37.95,4.26,37.95s13,3.6,31.8-4.53c16.59-7.2,18.67-15.08,18.67-15.08l-5.21-7.28-1.83-15.33s6-8.49,1-18-18.94-17.82-18.94-17.82l-6.19.95Z"
              />
              <g id="elfe9hu0cz10g">
                <path
                  className="animable"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: "0.85",
                    transformOrigin: "108.119px 258.467px",
                  }}
                  d="M91.41,223.27l-11.77,4.5c-2.33,1.07,1.88,15,2.92,31.37,1.06,16.8,4.26,37.95,4.26,37.95s13,3.6,31.8-4.53c16.59-7.2,18.67-15.08,18.67-15.08l-5.21-7.28-1.83-15.33s6-8.49,1-18-18.94-17.82-18.94-17.82l-6.19.95Z"
                />
              </g>
              <g id="elonohlelqnx">
                <path
                  className="animable"
                  style={{
                    opacity: "0.1",
                    transformOrigin: "107.135px 261.79px",
                  }}
                  d="M95.89,259.83a13.57,13.57,0,0,0,12.49,4.6,13.38,13.38,0,0,0,10-7.59s-.51,8.53-10.54,9.77S95.89,259.83,95.89,259.83Z"
                />
              </g>
            </g>
            <g
              className="animable"
              id="freepik--Head--inject-16"
              style={{ transformOrigin: "100.631px 203.974px" }}
            >
              <path
                className="animable"
                id="elbo0u9u38dws"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "102.17px 209.795px",
                }}
                d="M115.65,179.2c2.66,1.47,6.07,8,6.13,21.77,0,11.7-3.66,14.69-5.54,15.58s-5.57.48-9.15,0l.06,4.84c4.87,7.26,6.5,12,8.57,19-9.24-7-12.45-9.38-24.06-15.79l-.35-16.22s-2,2.1-5.69-.92c-3-2.49-4.11-6.79-1.89-9.18a5.13,5.13,0,0,1,8.2,1.4s-1.62-14.07,5.84-18.44S115.27,183.74,115.65,179.2Z"
              />
              <path
                className="animable"
                id="elmkc9ht62ut"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "109.161px 209.255px",
                }}
                d="M107.32,208l3.75,1a1.9,1.9,0,0,1-2.33,1.45A2,2,0,0,1,107.32,208Z"
              />
              <path
                className="animable"
                id="elywmn23uk70o"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "117.632px 189.736px",
                }}
                d="M119.51,191,115.7,190a1.86,1.86,0,0,1,2.29-1.47A2.06,2.06,0,0,1,119.51,191Z"
              />
              <path
                className="animable"
                id="elfiophmy856f"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "103.974px 192.047px",
                }}
                d="M102.41,193.55l3.37-2a1.87,1.87,0,0,0-2.62-.74A2.07,2.07,0,0,0,102.41,193.55Z"
              />
              <path
                className="animable"
                id="eltm2tyyvtalm"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "117.56px 196.576px",
                }}
                d="M119.2,196.41a1.61,1.61,0,0,1-1.41,1.8,1.65,1.65,0,1,1,1.41-1.8Z"
              />
              <path
                className="animable"
                id="elex25eioo44"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "105.303px 197.823px",
                }}
                d="M106.89,197.72a1.59,1.59,0,1,1-1.75-1.48A1.61,1.61,0,0,1,106.89,197.72Z"
              />
              <path
                className="animable"
                id="el1ddkiic9xwt"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "100.67px 214.985px",
                }}
                d="M107.09,216.53c-3.78-.39-11.58-2.4-12.86-5.43A7.91,7.91,0,0,0,97,214.93c2.37,1.92,10.11,3.94,10.11,3.94Z"
              />
              <path
                className="animable"
                id="elqxjdrv1r9ab"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "101.284px 196.763px",
                }}
                d="M102.77,197.07a.51.51,0,0,0-.24-.16l-.51-.17-.68-.22a5.58,5.58,0,0,0-.58-.18l-.36-.07a1.54,1.54,0,0,0-.48,0c-.12,0-.14.19-.11.29a.41.41,0,0,0,.28.28,2.29,2.29,0,0,0,.28.07l.19,0h.12l.17,0,.61.18a3.19,3.19,0,0,0,.8.18.77.77,0,0,0,.4-.06A.23.23,0,0,0,102.77,197.07Z"
              />
              <path
                className="animable"
                id="elspfyb46stqn"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "101.291px 198.341px",
                }}
                d="M102.68,198.31a.8.8,0,0,0-.58-.31,5.36,5.36,0,0,0-1,0c-.38,0-.76,0-1.13.08s-.13.58.14.6a9.41,9.41,0,0,0,1.4,0l.56,0h.26l.17,0c.1,0,.09,0,.15-.1A.11.11,0,0,0,102.68,198.31Z"
              />
              <path
                className="animable"
                id="eltp63k6pmrt"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "101.61px 199.612px",
                }}
                d="M102.65,199.11c-.1-.09-.24,0-.35,0l-.24.06-.5.17-.47.15-.2.05-.25.09a.21.21,0,0,0-.13.2v.05a.34.34,0,0,0,.17.26.47.47,0,0,0,.23,0H101l.23,0,.25-.07.49-.17a1.48,1.48,0,0,0,.59-.32.55.55,0,0,0,.15-.19C102.7,199.29,102.72,199.17,102.65,199.11Z"
              />
              <path
                className="animable"
                id="el14ftxj4l8g4d"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "100.081px 192.179px",
                }}
                d="M121.26,192.62a.09.09,0,0,0,0-.05c-.66-3.71-1.4-6.48-1.57-7.12a.93.93,0,0,0,0-.13c0,8.58-11.27,8.15-11.27,8.15,2.11-5.63-.71-7.9-.71-7.9-2.85,7.3-8.51,8.61-8.51,8.61,0-5.16-2.24-7.67-2.24-7.67,1.09,9-5,13.13-5,13.13a5.12,5.12,0,0,0-8.19-1.4c-2.23,2.39-1.12,6.7,1.89,9.19,3.65,3,5.69.92,5.69.92l.18,8.45c-.47-4-14.82-13.29-15.48-24.62-.64-11.06,3.19-18.34,15-23.23,10.48-4.36,20.22,2.91,20.22,2.91,5.71-.38,10.72,3.26,12.53,9.64A12.57,12.57,0,0,1,121.26,192.62Z"
              />
              <path
                className="animable"
                id="el0ma94y23llx9"
                style={{
                  fill: "rgb(240, 240, 240)",
                  transformOrigin: "91.741px 193.075px",
                }}
                d="M96.91,186.51a14.1,14.1,0,0,1-10.65,10.34,5.5,5.5,0,0,1,5.66,2.79S98.74,197,96.91,186.51Z"
              />
              <path
                className="animable"
                id="elmxyeg50s4ni"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "111.052px 198.068px",
                }}
                d="M124.39,191.1h-.76a22.76,22.76,0,0,0-7.54,1.31c-2.38,1.1-3.2,2.05-4.53,2.25s-2.36-.52-5-.91a25.16,25.16,0,0,0-8.07.89l-.81.21a1.51,1.51,0,0,0-.85,1.5,2.85,2.85,0,0,0,.83,1.49,1.85,1.85,0,0,1,.29.6,26.73,26.73,0,0,0,1.13,4.27,4.8,4.8,0,0,0,1.09,1.44,4.38,4.38,0,0,0,.54.39l.31.17a4.51,4.51,0,0,0,.92.31l.15,0,.25,0,.25,0a5.29,5.29,0,0,0,.8,0l.35,0,.43-.05a6.23,6.23,0,0,0,5.4-4c.77-1.78.48-4.11,2-4.32h.28c1.14.11,1.08,2.29,1.84,3.75a5.36,5.36,0,0,0,1.14,1.55,2,2,0,0,0,.27.23.71.71,0,0,0,.14.1l.15.1a.57.57,0,0,0,.13.08.56.56,0,0,0,.15.08l.11.06.08,0a4.38,4.38,0,0,0,1.34.36h.12A7,7,0,0,0,119,203a5.33,5.33,0,0,0,4.57-3.72,29.71,29.71,0,0,0,.8-4.54,1.68,1.68,0,0,1,.26-.62,3.4,3.4,0,0,0,.65-1.72C125.28,191.68,124.81,191.1,124.39,191.1Zm-15.68,8.47a5.63,5.63,0,0,1-1.07,2.49h0a5.16,5.16,0,0,1-3.57,1.84,3.63,3.63,0,0,1-3.52-1.21l-.12-.15a1.3,1.3,0,0,1-.1-.15l-.1-.15s0-.08-.07-.13l-.06-.1,0-.09c0-.06,0-.11-.07-.16h0a3.56,3.56,0,0,1-.19-.47h0l-.09-.28c0-.16-.1-.32-.13-.46a.31.31,0,0,1,0-.08l0-.09c-.29-1.13-.67-3.38-.12-4s2-1.34,4.51-1.44h.26a8.69,8.69,0,0,1,1.14,0l.44.05a8.76,8.76,0,0,1,1.11.21l.34.09.37.13.07,0,.14.06a2.13,2.13,0,0,1,.76.5C109,196.7,109,198.23,108.71,199.57Zm14.36-2.52a5.7,5.7,0,0,1-2.2,4.06,4.52,4.52,0,0,1-1.82.67,3.58,3.58,0,0,1-3.74-1.23h0l-.07-.1a1,1,0,0,0-.08-.11l0-.06c0-.06-.07-.12-.11-.17l-.1-.21-.05-.09a.14.14,0,0,1,0-.06.59.59,0,0,1,0-.08l0-.07a6,6,0,0,1-.26-.84c-.3-1.26-.49-2.75,0-3.53s2.24-1.83,4-2.3a11.54,11.54,0,0,1,1.13-.24l.13,0,.15,0,.39,0h.64a5.17,5.17,0,0,1,.57,0h.26l.14,0,.17,0,.27.08h0a2.17,2.17,0,0,1,.63.31C123.49,193.51,123.27,195.85,123.07,197.05Z"
              />
              <path
                className="animable"
                id="elno1va36sldh"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "94.24px 197.565px",
                }}
                d="M97.76,195.49l-7.14,2.57a6.9,6.9,0,0,1,1.3,1.58l5.94-1.92Z"
              />
              <path
                className="animable"
                id="eluwko8sri5yo"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "114.295px 201.42px",
                }}
                d="M111,196.94l1.24,9.17,5.35-2-6.08-7.38A1.2,1.2,0,0,0,111,196.94Z"
              />
            </g>
            <g
              className="animable"
              id="freepik--writting-hand--inject-16"
              style={{ transformOrigin: "126.424px 288.359px" }}
            >
              <path
                className="animable"
                id="elhsg0d6wbx89"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "143.134px 294.598px",
                }}
                d="M142.3,292l4,4.88a.19.19,0,0,1-.19.31l-6.19-1.45Z"
              />
              <path
                className="animable"
                id="elbt7yy8gm6qc"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "145.564px 296.583px",
                }}
                d="M146.11,297.21a.19.19,0,0,0,.19-.31l-.78-.95h0a1.1,1.1,0,0,1-.64.91l-.1,0Z"
              />
              <path
                className="animable"
                id="eliuz6ewoasmc"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "129.849px 286.84px",
                }}
                d="M117.32,281.68l.49.31.6.38,21.51,13.39a2.84,2.84,0,0,0,1.73-1.12,2.88,2.88,0,0,0,.64-2.62L120.8,278.64l-1.15-.72C120.37,278.43,118,282.18,117.32,281.68Z"
              />
              <path
                className="animable"
                id="elwydo7qeeow"
                style={{
                  fill: "rgb(235, 235, 235)",
                  transformOrigin: "120.993px 281.343px",
                }}
                d="M119.2,282.87l1.11.68c.32.21,1-.34,1.51-1.09.75-1,1.23-2.4.81-2.68l-.81-.51-.3-.18c.42.28-.06,1.7-.81,2.69-.54.71-1.15,1.25-1.47,1.1h0Z"
              />
              <path
                className="animable"
                id="el7ssvbsci5mh"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "120.148px 280.792px",
                }}
                d="M119.48,283c.73.49,3-3.28,2.32-3.77l-1.11-.69c.73.49-1.59,4.26-2.32,3.77Z"
              />
              <path
                className="animable"
                id="elcw59czdqk7o"
                style={{
                  fill: "rgb(235, 235, 235)",
                  transformOrigin: "119.111px 280.187px",
                }}
                d="M117.32,281.68l1.09.69c.71.48,3-3.14,2.39-3.73l0,0-1.11-.68C120.37,278.43,118,282.18,117.32,281.68Z"
              />
              <path
                className="animable"
                id="elsjqthkqlfd"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "116.043px 278.309px",
                }}
                d="M112.68,278.79l4.64,2.89c.31.22.94-.33,1.5-1.07.75-1,1.24-2.4.83-2.69h0L115,275c-.93-.57-2.33,1.17-2.64,2.53A1.14,1.14,0,0,0,112.68,278.79Z"
              />
              <path
                className="animable"
                id="elafzjvrcbwlf"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "131.378px 284.938px",
                }}
                d="M127.93,283.08a4.3,4.3,0,0,1,3.74.84c1.22.76,3,.89,3.14,1.49s-.71,1.51-.71,1.51Z"
              />
              <path
                className="animable"
                id="eldfuh8e1hf0c"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "124.901px 293.295px",
                }}
                d="M113.49,301.83c2.59-.24,11-.43,13.69-1a11.16,11.16,0,0,0,6.16-3.46c.4-.45.76-.94,1.15-1.4a3.31,3.31,0,0,1,1-1c.34-.19.71-.32,1-.52a3,3,0,0,0,1.45-2.28,5,5,0,0,1,.06-.56.75.75,0,0,1,.31-.46,1,1,0,0,1,.58-.05,9.05,9.05,0,0,0,2.2.11,4.11,4.11,0,0,0,1.56-.52c.35-.23,1-.9.42-1.25-.8-.48-1.57-1-2.2-1.29-3.31-1.56-6.07-1.85-9.71-2.18-1.68-.14-4-.14-5.7-.25-.72-.05-1.48-.19-2.24-.28l-1.09-.68a4.8,4.8,0,0,0-2,.69c-1,.57-2,1.48-3,2-2.49,1.33-7,1.38-10.63,1.24"
              />
              <g id="ell2f2e9u7sfi">
                <path
                  className="animable"
                  style={{
                    opacity: "0.15",
                    transformOrigin: "131.825px 288.525px",
                  }}
                  d="M146.3,297.13v-.23l-4.3-2.8-22.75-14.16c0-.07,0-.1,0-.1-.59,1.07-1.5,2.12-1.9,1.84l.49.31.6.38,21.51,13.39h0l6.19,1.45A.18.18,0,0,0,146.3,297.13Z"
                />
              </g>
              <g id="ely482nxqw41j">
                <path
                  className="animable"
                  style={{
                    opacity: "0.1",
                    transformOrigin: "113.778px 276.888px",
                  }}
                  d="M114.11,278.34a3.45,3.45,0,0,0,1.15-2.82.8.8,0,0,0-.42-.58c-.93-.31-2.19,1.31-2.49,2.6a1.16,1.16,0,0,0,.31,1.23C113,279,113.56,278.85,114.11,278.34Z"
                />
              </g>
            </g>
            <g
              className="animable"
              id="freepik--Notebook--inject-16"
              style={{ transformOrigin: "158.948px 283.023px" }}
            >
              <polygon
                className="animable"
                id="el92pxud27ewe"
                style={{
                  fill: "rgb(245, 245, 245)",
                  transformOrigin: "157.935px 283.3px",
                }}
                points="174.02 259.61 146.66 272.62 139.52 304.61 141.85 306.99 167.58 293.9 176.35 261.99 174.02 259.61"
              />
              <polygon
                className="animable"
                id="elue5ai1s1hhd"
                style={{
                  fill: "rgb(235, 235, 235)",
                  transformOrigin: "144.255px 289.805px",
                }}
                points="148.99 275 141.85 306.99 139.52 304.61 146.66 272.62 148.99 275"
              />
              <polygon
                className="animable"
                id="eljd16aa8vqqm"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "159.39px 284.76px",
                }}
                points="176.7 261.34 148.73 274.64 141.35 307.4 142.08 308.18 168.44 294.8 177.43 262.11 176.7 261.34"
              />
              <polygon
                className="animable"
                id="elbmndhvqjhkc"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "145.405px 291.41px",
                }}
                points="149.46 275.41 142.08 308.18 141.35 307.4 148.73 274.64 149.46 275.41"
              />
              <polygon
                className="animable"
                id="el4ipe01vhk1q"
                style={{
                  fill: "rgb(11, 229, 179)",
                  transformOrigin: "159.755px 285.145px",
                }}
                points="177.43 262.11 149.46 275.41 142.08 308.18 168.44 294.8 177.43 262.11"
              />
              <g id="eldwgxe3jay8f">
                <polygon
                  className="animable"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: "0.7",
                    transformOrigin: "159.39px 284.76px",
                  }}
                  points="176.7 261.34 148.73 274.64 141.35 307.4 142.08 308.18 168.44 294.8 177.43 262.11 176.7 261.34"
                />
              </g>
              <g id="elnqctyffghu">
                <polygon
                  className="animable"
                  style={{
                    opacity: "0.15",
                    transformOrigin: "145.405px 291.41px",
                  }}
                  points="149.46 275.41 142.08 308.18 141.35 307.4 148.73 274.64 149.46 275.41"
                />
              </g>
              <g id="elobriradvxbg">
                <g
                  className="animable"
                  style={{
                    opacity: "0.2",
                    transformOrigin: "166.91px 288.089px",
                  }}
                >
                  <path
                    className="animable"
                    id="elb635w9fgxkq"
                    style={{ transformOrigin: "166.91px 288.089px" }}
                    d="M163.2,287c.32.8,3,2.57,6.78,2.25l.64-2.36Z"
                  />
                </g>
              </g>
              <g id="elxzttpvwatf8">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "151.235px 276.636px",
                  }}
                  d="M150.64,276.92c-.12.43.05.64.38.49a1.85,1.85,0,0,0,.81-1.06c.12-.42-.05-.64-.38-.49A1.85,1.85,0,0,0,150.64,276.92Z"
                />
              </g>
              <g id="el9izihpcu62">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "155.081px 274.806px",
                  }}
                  d="M154.48,275.09c-.11.43.06.64.39.49a1.84,1.84,0,0,0,.8-1.06c.12-.42,0-.64-.38-.49A1.85,1.85,0,0,0,154.48,275.09Z"
                />
              </g>
              <g id="ellgjbsfcpado">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "158.919px 272.976px",
                  }}
                  d="M158.33,273.26c-.12.43,0,.64.38.49a1.85,1.85,0,0,0,.81-1.06c.11-.42-.06-.64-.39-.49A1.84,1.84,0,0,0,158.33,273.26Z"
                />
              </g>
              <g id="ellv5mqfquf78">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "162.765px 271.145px",
                  }}
                  d="M162.17,271.43c-.12.42.05.64.38.49a1.85,1.85,0,0,0,.81-1.06c.12-.42-.05-.64-.38-.49A1.85,1.85,0,0,0,162.17,271.43Z"
                />
              </g>
              <g id="elg74acjc381e">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "166.601px 269.315px",
                  }}
                  d="M166,269.6c-.11.42.06.64.39.49a1.84,1.84,0,0,0,.8-1.06c.12-.42,0-.64-.38-.49A1.85,1.85,0,0,0,166,269.6Z"
                />
              </g>
              <g id="elv152ct0eaoi">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "170.449px 267.485px",
                  }}
                  d="M169.86,267.77c-.12.42,0,.64.38.49a1.85,1.85,0,0,0,.81-1.06c.11-.42-.06-.64-.39-.49A1.84,1.84,0,0,0,169.86,267.77Z"
                />
              </g>
              <g id="el5gtfla36ecw">
                <path
                  className="animable"
                  style={{
                    opacity: "0.35",
                    transformOrigin: "174.298px 265.655px",
                  }}
                  d="M173.7,265.94c-.12.42.05.64.38.49a1.85,1.85,0,0,0,.81-1.06c.12-.42,0-.64-.38-.49A1.85,1.85,0,0,0,173.7,265.94Z"
                />
              </g>
              <path
                className="animable"
                id="el0k4eymai51e"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "150.149px 272.963px",
                }}
                d="M151.06,269.63a2,2,0,0,0-2-.74,2.2,2.2,0,0,0-1.37,1.81,5,5,0,0,0-.11,1.47l.55-.26a4.8,4.8,0,0,1,.11-1.09,1.7,1.7,0,0,1,1-1.39,1.52,1.52,0,0,1,1.42.59,6.27,6.27,0,0,1,1.41,5.13,2.48,2.48,0,0,1-.27.74,1.27,1.27,0,0,1-.71.65,1,1,0,0,1-.3,0,1.54,1.54,0,0,0-.15.35,1.48,1.48,0,0,0,0,.19l.23,0a1.83,1.83,0,0,0,.4-.05,1.39,1.39,0,0,0,.28-.12,2.37,2.37,0,0,0,1.09-1.69A6.82,6.82,0,0,0,151.06,269.63Z"
              />
              <path
                className="animable"
                id="el3xbau18q9c8"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "154.01px 271.132px",
                }}
                d="M154.91,267.8a2,2,0,0,0-2-.74,2.22,2.22,0,0,0-1.37,1.81,5.4,5.4,0,0,0-.1,1.47l.54-.26a4.8,4.8,0,0,1,.11-1.09,1.7,1.7,0,0,1,1-1.39,1.5,1.5,0,0,1,1.42.59,6.2,6.2,0,0,1,1.41,5.13,2.79,2.79,0,0,1-.26.74,1.33,1.33,0,0,1-.71.65,1,1,0,0,1-.3,0,1.19,1.19,0,0,0-.15.35c0,.07,0,.13,0,.18a.91.91,0,0,0,.23,0,1.45,1.45,0,0,0,.41-.06,1,1,0,0,0,.27-.11,2.38,2.38,0,0,0,1.1-1.69A6.89,6.89,0,0,0,154.91,267.8Z"
              />
              <path
                className="animable"
                id="elmznun55jwco"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "157.855px 269.298px",
                }}
                d="M158.75,266a2,2,0,0,0-2-.73A2.19,2.19,0,0,0,155.4,267a5,5,0,0,0-.11,1.47l.55-.26a5.45,5.45,0,0,1,.1-1.09,1.72,1.72,0,0,1,1-1.39,1.53,1.53,0,0,1,1.43.59,6.23,6.23,0,0,1,1.4,5.13,2.79,2.79,0,0,1-.26.74,1.3,1.3,0,0,1-.71.65,1,1,0,0,1-.3,0,1.19,1.19,0,0,0-.15.35c0,.06,0,.12,0,.18l.24,0a1.44,1.44,0,0,0,.4-.06,1.36,1.36,0,0,0,.28-.11,2.4,2.4,0,0,0,1.09-1.69A6.89,6.89,0,0,0,158.75,266Z"
              />
              <path
                className="animable"
                id="el0z3o5pp77edj"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "161.678px 267.472px",
                }}
                d="M162.59,264.13a2,2,0,0,0-2-.73,2.2,2.2,0,0,0-1.37,1.81,5,5,0,0,0-.11,1.47l.55-.26a4.8,4.8,0,0,1,.11-1.09,1.68,1.68,0,0,1,1-1.39,1.52,1.52,0,0,1,1.42.59,6.27,6.27,0,0,1,1.41,5.13,2.58,2.58,0,0,1-.27.74,1.27,1.27,0,0,1-.71.65,1,1,0,0,1-.3,0,1.54,1.54,0,0,0-.15.35,1.13,1.13,0,0,0,0,.18.85.85,0,0,0,.23,0,1.39,1.39,0,0,0,.4-.06,1.36,1.36,0,0,0,.28-.11,2.37,2.37,0,0,0,1.09-1.69A6.85,6.85,0,0,0,162.59,264.13Z"
              />
              <path
                className="animable"
                id="elbct16y1vet"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "165.531px 265.644px",
                }}
                d="M166.44,262.3a2.06,2.06,0,0,0-2-.73,2.22,2.22,0,0,0-1.37,1.81,5.4,5.4,0,0,0-.1,1.47l.54-.26a5,5,0,0,1,.11-1.1,1.68,1.68,0,0,1,1-1.38,1.5,1.5,0,0,1,1.42.59,6.2,6.2,0,0,1,1.41,5.13,2.92,2.92,0,0,1-.26.74,1.33,1.33,0,0,1-.71.65,1,1,0,0,1-.3,0,1.19,1.19,0,0,0-.15.35,1.16,1.16,0,0,0,0,.18.91.91,0,0,0,.23,0,1.45,1.45,0,0,0,.41-.06,1.53,1.53,0,0,0,.27-.11A2.38,2.38,0,0,0,168,268,6.92,6.92,0,0,0,166.44,262.3Z"
              />
              <path
                className="animable"
                id="elivey4mp9p6j"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "169.371px 263.811px",
                }}
                d="M170.28,260.47a2,2,0,0,0-2-.73,2.19,2.19,0,0,0-1.37,1.81,5,5,0,0,0-.11,1.47l.55-.26a5.63,5.63,0,0,1,.1-1.1,1.72,1.72,0,0,1,1-1.38,1.53,1.53,0,0,1,1.43.59,6.23,6.23,0,0,1,1.4,5.13,2.92,2.92,0,0,1-.26.74,1.3,1.3,0,0,1-.71.65,1,1,0,0,1-.3,0,1.19,1.19,0,0,0-.15.35c0,.06,0,.12,0,.18a1,1,0,0,0,.24,0,1.44,1.44,0,0,0,.4-.06,1.36,1.36,0,0,0,.28-.11,2.43,2.43,0,0,0,1.09-1.69A6.89,6.89,0,0,0,170.28,260.47Z"
              />
              <path
                className="animable"
                id="elm9hztnujza"
                style={{
                  fill: "rgb(224, 224, 224)",
                  transformOrigin: "173.209px 261.982px",
                }}
                d="M174.12,258.64a2,2,0,0,0-2-.73,2.19,2.19,0,0,0-1.37,1.8,5.12,5.12,0,0,0-.11,1.48l.55-.26a5,5,0,0,1,.11-1.1,1.68,1.68,0,0,1,1-1.38,1.52,1.52,0,0,1,1.42.59,6.27,6.27,0,0,1,1.41,5.13,2.58,2.58,0,0,1-.27.74,1.27,1.27,0,0,1-.71.65,1,1,0,0,1-.3,0,1.54,1.54,0,0,0-.15.35,1.13,1.13,0,0,0,0,.18.85.85,0,0,0,.23,0,1.39,1.39,0,0,0,.4-.06,1.36,1.36,0,0,0,.28-.11,2.4,2.4,0,0,0,1.09-1.69A6.85,6.85,0,0,0,174.12,258.64Z"
              />
              <path
                className="animable"
                id="elb9frd45syi7"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "169.215px 278.042px",
                }}
                d="M175.66,268.53l-1.54,5.63c-.76,2.73-6,3.74-8.78,4.09-5.4.67-6,1.84-4.71,5.67,1.2,3.54,4.71,4.87,9.58,4.3a8.83,8.83,0,0,0,6.68-5.84c1.58-4.51.73-9.34,1.36-12S177,267,175.66,268.53Z"
              />
            </g>
          </g>
          <g
            className="animable"
            id="freepik--arm--inject-16"
            style={{ transformOrigin: "88.368px 265.86px" }}
          >
            <path
              className="animable"
              id="elh0y9e780f7"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "88.8171px 266px",
              }}
              d="M106.59,288.65c-7.07-.27-23.18-2.49-23.18-2.49L87,254.81c1.81-7.44-3.32-24.53-7.35-27-1.79.53-5.47,1.59-9.53,7.74-2.22,3.35-2.73,9.09-4.27,23-1.1,9.86-1.53,23.38-1.67,32.31C64,300.72,68.05,303.45,77,304c15,.89,30.57-1.61,36.46-2.15"
            />
            <path
              className="animable"
              id="el66j7f1cp5k"
              style={{
                fill: "rgb(11, 229, 179)",
                transformOrigin: "75.953px 265.86px",
              }}
              d="M80.53,227.38c-5.87,1.44-8.17,3.36-11,8.13s-4,19.23-5.32,34.63-.93,24.38-.68,26.95,2.5,6.5,8.87,7a91,91,0,0,0,12.78.05S83.91,293,88.63,286.84L83.76,286l4.54-34.24S87.91,234,80.53,227.38Z"
            />
            <g id="el351owbdbgh2">
              <path
                className="animable"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.7",
                  transformOrigin: "75.953px 265.86px",
                }}
                d="M80.53,227.38c-5.87,1.44-8.17,3.36-11,8.13s-4,19.23-5.32,34.63-.93,24.38-.68,26.95,2.5,6.5,8.87,7a91,91,0,0,0,12.78.05S83.91,293,88.63,286.84L83.76,286l4.54-34.24S87.91,234,80.53,227.38Z"
              />
            </g>
            <g id="elrzpcsagc2y">
              <path
                className="animable"
                style={{ opacity: "0.15", transformOrigin: "78.5px 285.83px" }}
                d="M83.76,286A20.61,20.61,0,0,0,73,288.06s2.3-3.72,11-4.46Z"
              />
            </g>
          </g>
          <path
            className="animable"
            id="ele1s0cle0rvj"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "74.7px 328.678px",
            }}
            d="M112.79,395.85V342.78a12.28,12.28,0,0,0-5.52-9.57L56.06,303.66a3.64,3.64,0,0,1,0-6.31l1.25-.71L53,270.44a14.68,14.68,0,0,0-6.37-9.51l-4.5-2.6c-3-1.76-5.52-.32-5.52,3.19v23.3L36.66,352a12.27,12.27,0,0,0,5.53,9.57L107.27,399C110.3,400.8,112.79,399.36,112.79,395.85Z"
          />
          <path
            className="animable"
            id="elmmrnhg0wefe"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "91.282px 346.839px",
            }}
            d="M128.33,333.8v53.08c0,.11,0,.24,0,.36a12.33,12.33,0,0,1-5.46,9.18.07.07,0,0,0,0,0L118.32,399a2.06,2.06,0,0,1-.42.21l-.23.12-.07,0a3,3,0,0,1-.44.17,12.84,12.84,0,0,1-8.13.23,7.89,7.89,0,0,1-1-.36c2.66,1.1,4.71-.39,4.72-3.57h0V342.79a12.25,12.25,0,0,0-5.52-9.57l-10-5.8L56.05,303.65a3.64,3.64,0,0,1,0-6.3l4.57-2.64a12.29,12.29,0,0,1,11.05,0l41.12,23.74,10,5.78A12.24,12.24,0,0,1,128.33,333.8Z"
          />
          <path
            className="animable"
            id="elz2d9oofkrd8"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "118.19px 364.345px",
            }}
            d="M112.79,342.79v53.06h0c0,3.18-2.06,4.67-4.72,3.57a7.89,7.89,0,0,0,1,.36,12.84,12.84,0,0,0,8.13-.23,3,3,0,0,0,.44-.17l.07,0,.23-.12a2.06,2.06,0,0,0,.42-.21l4.49-2.59a.07.07,0,0,1,0,0,12.33,12.33,0,0,0,5.46-9.18c0-.12,0-.25,0-.36V333.8a11.34,11.34,0,0,0-1.62-5.44l-15.54,9A11.34,11.34,0,0,1,112.79,342.79Z"
          />
        </g>
      </g>
      <g
        className="animable"
        id="freepik--Line--inject-16"
        style={{ transformOrigin: "259.859px 124.559px" }}
      >
        <g
          className="animable"
          id="freepik--Lines--inject-16"
          style={{ transformOrigin: "259.859px 124.559px" }}
        >
          <path
            className="animable"
            id="eltx00vxntlza"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "257.597px 124.559px",
            }}
            d="M101.56,160a4.05,4.05,0,0,0,3-6.16c-.91-1.28-2.6-1.78-4-2.38a5.66,5.66,0,0,1-2.26-1.36c-1.36-1.76.49-3.47,1.82-4.38,1.68-1.15,3.68-1.91,5-3.55a6.56,6.56,0,0,0,1.36-4.64c-.36-4-3.75-5.76-7.07-7.2-4.65-2-9.27-4-11.38-8.94-2.31-5.43.62-12.32,5.42-15.34a12.66,12.66,0,0,1,16.07,2.3c4.1,4.39,5.76,11.38,3.31,17-4.93,11.26-24.28,8.07-27.42-3A17.37,17.37,0,0,1,90,105.54a16.13,16.13,0,0,1,14-4,15.88,15.88,0,0,1,11.94,11.61,27,27,0,0,1,1,9,13.06,13.06,0,0,1-4.4,8.28,18.58,18.58,0,0,1-16,4.62,18.34,18.34,0,0,1-12.75-10.2c-3.6-8.33-1.22-20.13,7.46-24.36,6.06-3,12.58-3.49,18.31.48a24.18,24.18,0,0,1,9.79,13.29,17.9,17.9,0,0,1-4.12,17,20.84,20.84,0,0,1-14,6.17,20.4,20.4,0,0,1-13.94-4.18c-4.53-3.66-7-9.51-7.51-15.22-1-10.73,5.15-19.54,14.84-23.75,10.23-4.43,22-3.53,32.53-.75,11.13,2.94,21.8,7.79,31.9,13.26,5.34,2.89,10.55,6,16,8.59a148.3,148.3,0,0,0,15.16,6.27c9.3,3.24,19,5.52,28.86,5.52a71.52,71.52,0,0,0,27.41-5,45.76,45.76,0,0,0,20.11-15.83C269,103,271,99.45,270.77,95.21c-.23-3.66-2.52-6.5-6.42-6.22-4.64.34-7.2,4.67-9.22,8.33l.57.13c-1.57-2.86-3.31-6-6.27-7.63-2.25-1.24-5.41-1.46-7.48.24-4.76,3.9-1.37,11.67,1.51,15.59,6.79,9.24,18.12,14.7,28.72,18.19,15.2,5,31.72,6.95,47.51,3.78,13.61-2.74,26-9.07,38.13-15.6,7.19-3.88,14.32-7.94,21.84-11.16,8.08-3.47,17.33-6.19,26-3.39,7.36,2.37,14.29,10.1,12.2,18.31-1.77,7-10.4,11.88-16.76,7.49-5.4-3.73-14.44-16.38-4.27-20,6.43-2.3,14.9,1.15,19.71,5.45,2.81,2.53,5,6.2,3.36,10s-5.92,5.36-9.66,5.52c-8,.34-16.35-5.29-16.5-13.82a12,12,0,0,1,4.36-9.73c3.09-2.42,7.16-3,11-2.56,7.58.85,15.71,5.44,19.4,12.27,3.48,6.45,2.16,15.85-5,19.23-6.42,3-15.16,1.68-21.52-.87s-12.31-7.48-14.29-14.35c-2.22-7.7,1.81-16.71,10.8-16.06,8.38.61,15.7,8.12,17.35,16.14,1.52,7.38-2.33,16-9.78,18.47-6.85,2.27-16-2-16.14-9.83-.15-7.09,7.19-14,14-9.63,2.95,1.9,5.1,5.57,4.31,9.14s-5.13,7-8.6,4.41a7.91,7.91,0,0,1-2.52-7.91c.89-3.58,4.66-5.49,8.09-5.82a15.89,15.89,0,0,1,10.65,2.84c1.72,1.3,3,3.46,1.63,5.51-1.8,2.66-4.5.25-5.09-2a7,7,0,0,1,3.49-7.91c3.66-1.68,7.65,1.54,8.2,5.21.25,1.68-.19,3.65-2,4.26a4.19,4.19,0,0,1-4.73-1.77c-2.07-3.81,3.9-7.12,6.88-5,3.74,2.62,2.25,8.21-1.33,10.08a8.19,8.19,0,0,1-10-2,10.59,10.59,0,0,1-1.93-10.34,11.7,11.7,0,0,1,7.23-6.64c7.69-2.67,16.75,2.84,17,11.24.19,7.14-5.78,13.74-12.73,14.81-7.85,1.2-16.05-3.72-19.58-10.67a13.69,13.69,0,0,1-1.21-10.16c1.38-4.28,5.87-5.88,10.06-5.37a14,14,0,0,1,11.6,17.93c-1.19,3.88-3.91,6.25-6.81,8.87-2.46,2.24-4.68,5-4.41,8.51.21,2.78,2,4.26,4.48,5.23,1.22.48,3.63,1,3.64,2.72s-2,2.29-3.24,2.81c-2.13.89-4.34,2-4.05,4.71a4.49,4.49,0,0,0,4.2,4.09c.8,0,.35-1.09-.28-1.1-2.62-.08-3.62-3.58-1.82-5.26,1.28-1.2,3.2-1.47,4.66-2.37,2.53-1.55,1.87-4.34-.53-5.6-1.77-.94-4.11-1.17-5.26-3-1.42-2.22-.49-5.31,1-7.27,2.75-3.65,6.93-5.74,8.85-10.07a15.25,15.25,0,0,0-8-20.15c-3.74-1.6-8.7-1.93-12.15.56-2.9,2.1-3.77,5.77-3.44,9.18.78,8,7.75,14.89,15.34,17a16.39,16.39,0,0,0,19.3-8.59,13.8,13.8,0,0,0-7.38-18.77c-6.77-2.82-16.12.55-17.83,8.16-1.53,6.82,4.1,14.78,11.51,13.35,3.49-.67,6.38-3.42,6.31-7.12,0-3-2.06-6.14-5.25-6.46-2.91-.3-6.15,2-6.18,5,0,2.75,2.77,4.73,5.36,4.67,3.35-.09,4.29-3.47,3.5-6.26-.86-3-3.61-5.68-6.8-5.87-6.44-.38-9.39,9.32-4.22,12.91,2.73,1.88,5.64-.9,5.18-3.85-.56-3.51-4.71-5.46-7.72-6.37-6.28-1.88-16.09.17-15.35,8.49a8.6,8.6,0,0,0,4.11,6.85c3.06,1.6,6.53-.14,8.19-2.93,3.69-6.22-2.55-14.39-9.27-14.32-7.27.08-11.73,8.81-9.43,15.2,2.48,6.89,11.31,10,17.86,7.26,7.69-3.22,11.09-12.41,9-20.15-2.13-7.92-9.37-15.08-17.7-16a10.84,10.84,0,0,0-10.42,4.44A14.84,14.84,0,0,0,386.53,113c1.53,7.59,7.64,13.25,14.51,16.25a35.2,35.2,0,0,0,11.32,2.82c4.23.33,9,.11,12.73-2.1,6.82-4,7.62-13.58,4-20-4-7.16-12.44-12-20.49-12.79-4-.39-8.33.33-11.48,3a12.76,12.76,0,0,0-4.2,10.2c.31,8.33,7.74,14.2,15.7,14.73,3.69.25,7.79-.69,10.43-3.44a8.11,8.11,0,0,0,1.17-9.53c-3.43-6.56-12.5-10.52-19.66-10.43-3.18,0-6.53,1-8.2,4-2.13,3.72-.36,8,1.85,11.25s5.49,7.26,9.51,8.53a11.14,11.14,0,0,0,9.64-1.82c6.78-4.74,7-13.57,2.28-19.89-5.7-7.68-15.59-9.34-24.51-7.61-10.31,2-19.83,7.55-29,12.49-7.59,4.09-15.15,8.3-23.07,11.76a92.26,92.26,0,0,1-25.45,7.34,91.19,91.19,0,0,1-31-1.83A87.54,87.54,0,0,1,256.5,116c-5.37-3.2-10.69-7.36-13.92-12.82-2.12-3.6-4.19-11.19,1.16-13.21s9.2,3.69,11.42,7.7c.11.21.41.42.57.13,1.51-2.73,3.16-5.76,6-7.26,2.54-1.32,6.34-1.16,7.72,1.72,2.49,5.21-1.57,11.17-4.63,15.13-6.09,7.88-14.82,13.14-24.27,16a73.87,73.87,0,0,1-32.11,2.22c-12.07-1.87-23.78-6.26-34.71-11.61-6.1-3-11.88-6.52-17.9-9.64a172.87,172.87,0,0,0-17.34-7.83c-10.3-3.94-21.51-6.89-32.63-5.9-10.21.91-21.11,6-25.15,16-3.68,9.11-1.26,21.41,6.75,27.51s20.37,5.13,27.53-1.73c8.07-7.74,6.53-20.19-.58-28-3.72-4.1-8.72-7.41-14.45-7.16a19.47,19.47,0,0,0-12.61,5.18,20.49,20.49,0,0,0-2.54,25.26,18.6,18.6,0,0,0,28.15,3c4.14-3.91,5-8.82,4-14.25-.86-5.13-2.63-9.68-6.93-12.88-8.4-6.26-20.67-2.35-24.39,7.29-1.79,4.62-2,10.45.75,14.76,2.84,4.51,8.41,6.86,13.57,7.14,4.89.26,9.73-1.3,12.39-5.63,2.5-4.07,2.47-9.35.82-13.72-1.79-4.72-5.71-8.79-10.78-9.82a13.11,13.11,0,0,0-13.37,5.93c-2.49,3.95-3,9.22-.74,13.36s6.7,6,11,7.87c2.36,1,5.11,2.16,6.23,4.65,1.47,3.26-.16,6.34-3,8.1-2,1.24-7.07,3.86-4.4,6.93,1.18,1.35,3.24,1.66,4.75,2.52a3.19,3.19,0,0,1,1.64,4.09,3.44,3.44,0,0,1-3.09,2.28c-.26,0-.18.57.09.56Z"
          />
          <path
            className="animable"
            id="elai3m5e2vxcn"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "419.446px 104.714px",
            }}
            d="M424,115.15a6.52,6.52,0,0,0,2.11,3.68,7.52,7.52,0,0,0,3.82,1.57c3.23.45,7.36-.23,9.21-3.18a12,12,0,0,0,1.51-5.64,19.57,19.57,0,0,0-5.77-15.11c-4.13-4-10.84-7-16.57-5a10.6,10.6,0,0,0-6.51,6.82,8,8,0,0,0-.12,5.15,10.71,10.71,0,0,0,2.51,3.92,15.11,15.11,0,0,0,8.58,4.42c3.38.44,7.27-.95,8.39-4.45s-.38-7.7-2.34-10.66A17.16,17.16,0,0,0,408.42,90a17.51,17.51,0,0,0-8.23,6.45c-1.89,2.84-2.72,6.47-1.19,9.66a9.69,9.69,0,0,0,8.69,5.31c3.67,0,7.74-1.79,9.56-5.09s.15-6.92-3-8.47c-3.36-1.64-7.57-.33-10.12,2.2a9.87,9.87,0,0,0-2.85,8.74,9.23,9.23,0,0,0,2.34,4.41c.37.39,1.2.06.75-.41a8.2,8.2,0,0,1-1.76-8.52,9.63,9.63,0,0,1,6.61-6.06,6.83,6.83,0,0,1,5.11.59,5.6,5.6,0,0,1,2.68,3.71c.64,3.55-2.81,6.38-5.8,7.42a9.27,9.27,0,0,1-9.69-1.85,8.05,8.05,0,0,1-1.66-8.78,15.09,15.09,0,0,1,6.21-7.07,16,16,0,0,1,9.74-2.4,16.16,16.16,0,0,1,14.45,12.67,8.18,8.18,0,0,1-.42,5.26,6,6,0,0,1-3.95,3c-2.8.73-5.84-.26-8.24-1.73s-4.73-3.75-5.26-6.6c-.59-3.13,1.22-6.7,3.63-8.63,4.48-3.59,10.83-2,15.25.87A18.77,18.77,0,0,1,439.86,111a13.09,13.09,0,0,1-1.06,5.21,6.13,6.13,0,0,1-4.09,3.23c-2.59.73-6,.8-8.29-.88a6.59,6.59,0,0,1-2.26-3.48c-.06-.2-.23-.07-.2.1Z"
          />
        </g>
      </g>
      <defs />
    </svg>
  );
};

export default Illus1;
